(function() { 
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; }, 
      hasProp = {}.hasOwnProperty; 


  window.HeaderView = (function(superClass) { 
    extend(HeaderView, superClass); 

    function HeaderView() { 
      return HeaderView.__super__.constructor.apply(this, arguments); 
    } 

    HeaderView.prototype.events = { 
      "click .mobile-header-search-toggle": "toggleSearch", 
      "blur .header-search-input": "toggleSearch" 
    }; 

    HeaderView.prototype.initialize = function() { 
      if (Pacific.settings["use-logo"]) { 
        this.fixWonkyLogo(); 
        return $(window).resize((function(_this) { 
          return function() { 
            return _this.fixWonkyLogo(); 
          }; 
        })(this)); 
      } 
    }; 

    HeaderView.prototype.fixWonkyLogo = function() { 
      var actualRatio, logo, naturalRatio, newHeight; 
      if ($("html").hasClass("lt-ie9")) { 
        return; 
      } 
      logo = this.$(".logo-retina").is(":visible") ? this.$(".logo-retina") : this.$(".logo-regular"); 
      naturalRatio = logo[0].naturalWidth / logo[0].naturalHeight; 
      actualRatio = logo[0].width / parseInt(Pacific.settings["logo-height"], 10); 
      newHeight = naturalRatio.toFixed(2) !== actualRatio.toFixed(2) ? "auto" : Pacific.settings["logo-height"]; 
      return this.$(".logo-retina, .logo-regular").css({ 
        height: newHeight 
      }); 
    }; 

    HeaderView.prototype.toggleSearch = function() { 
      var form; var aa; 
      if (!(document.documentElement.clientWidth > 1020)) { 
        form = this.$(".header-search-form"); 
 
        //CODE ADDED BY PRABHU 20151103-2045 FOR MOBILE RESPONSIVE SEARCH TOGGLE 
        aa = $("#opt").val(); 

        if (form.hasClass("active")) { 
          if (aa > 0) {  
            return form.addClass("active").find("input").focus(); 
            $('.search-ajax-results').show(); 
          }else{ 
            return form.removeClass("active"); 
            $('.search-ajax-results').hide(); 
          } 
        } else { 

          return form.addClass("active").find("input").focus(); 
        } 
        //CODE ADDED BY PRABHU 20151103-2045 FOR MOBILE RESPONSIVE SEARCH TOGGLE 

        /*  if (form.hasClass("active")) { 


          return form.removeClass("active"); 
        } else { 
          return form.addClass("active").find("input").focus(); 
        } */ 
      } 
    }; 

    return HeaderView; 

  })(Backbone.View); 

}).call(this); 

(function() { 
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; }, 
      hasProp = {}.hasOwnProperty; 

  window.CurrencyView = (function(superClass) { 
    extend(CurrencyView, superClass); 

    function CurrencyView() { 
      return CurrencyView.__super__.constructor.apply(this, arguments); 
    } 

    CurrencyView.prototype.events = { 
      "change [name=currencies]": "convertAll", 
      "switch-currency": "switchCurrency", 
      "reset-currency": "resetCurrency" 
    }; 

    CurrencyView.prototype.initialize = function() { 
      var cents, doubleMoney, i, j, len, len1, money, ref, ref1; 
      Currency.format = Pacific.settings["currency-switcher-format"]; 
      Currency.money_with_currency_format = {}; 
      Currency.money_with_currency_format[Shop.currency] = Shop.moneyFormatCurrency; 
      Currency.money_format = {}; 
      Currency.money_format[Shop.currency] = Shop.moneyFormat; 
      this.defaultCurrency = Pacific.settings["currency-switcher-default"] || Shop.currency; 
      this.cookieCurrency = Currency.cookie.read(); 
      if (this.cookieCurrency) { 
        this.$("[name=currencies]").val(this.cookieCurrency); 
      } 
      ref = $("span.money span.money"); 
      for (i = 0, len = ref.length; i < len; i++) { 
        doubleMoney = ref[i]; 
        $(doubleMoney).parents("span.money").removeClass("money"); 
      } 
      ref1 = $("span.money"); 
      for (j = 0, len1 = ref1.length; j < len1; j++) { 
        money = ref1[j]; 
        $(money).attr("data-currency-" + Shop.currency, $(money).html()); 
        if (Currency.format === "money_with_currency_format") { 
          cents = parseInt($(money).html().replace(/[^0-9]/g, ""), 10); 
          $(money).attr("data-currency-" + Shop.currency, Shopify.formatMoney(cents, Shop.moneyFormat)); 
          $(money).html(Shopify.formatMoney(cents, Shop.moneyFormat)); 
        } 
      } 
      this.switchCurrency(); 
      return this.$(".selected-currency").text(Currency.currentCurrency); 
    }; 

    CurrencyView.prototype.resetCurrency = function() { 
      return Currency.convertAll(this.defaultCurrency, this.$("[name=currencies]").val()); 
    }; 

    CurrencyView.prototype.switchCurrency = function() { 
      if (this.cookieCurrency === null) { 
        if (Shop.currency === !this.defaultCurrency) { 
          return Currency.convertAll(Shop.currency, this.defaultCurrency); 
        } else { 
          return Currency.currentCurrency = this.defaultCurrency; 
        } 
      } else if (this.$("[name=currencies]").size() && this.$("[name=currencies] option[value='" + this.cookieCurrency + "']").size() === 0) { 
        Currency.currentCurrency = Shop.currency; 
        return Currency.cookie.write(Shop.currency); 
      } else if (this.cookieCurrency === Shop.currency) { 
        return Currency.currentCurrency = Shop.currency; 
      } else { 
        return Currency.convertAll(Shop.currency, this.cookieCurrency); 
      } 
    }; 

    CurrencyView.prototype.convertAll = function(e, variant, selector) { 
      var newCurrency; 
      newCurrency = $(e.target).val(); 
      Currency.convertAll(Currency.currentCurrency, newCurrency); 
      this.$(".selected-currency").text(Currency.currentCurrency); 
      return this.cookieCurrency = newCurrency; 
    }; 

    return CurrencyView; 

  })(Backbone.View); 

}).call(this); 

(function() { 
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; }, 
      hasProp = {}.hasOwnProperty; 

  window.NavigationView = (function(superClass) { 
    extend(NavigationView, superClass); 

    function NavigationView() { 
      return NavigationView.__super__.constructor.apply(this, arguments); 
    } 

    NavigationView.prototype.events = { 
      "click .mobile-tier-toggle": "toggleMobileTier", 
      "click .has-children > a": "changeTier", 
      "click .mega-nav-breadcrumbs span": "previousTier", 
      "mouseenter .mega-nav": "setMegaNav", 
      "mouseout .mega-nav": "resetMegaNav" 
    }; 

    NavigationView.prototype.initialize = function() { 
      this.transitionend = (function(transition) { 
        var transEndEventNames; 
        transEndEventNames = { 
          "-webkit-transition": "webkitTransitionEnd", 
          "-moz-transition": "transitionend", 
          "-o-transition": "oTransitionEnd", 
          transition: "transitionend" 
        }; 
        return transEndEventNames[transition]; 
      })(Modernizr.prefixed("transition")); 
      this.checkDropdownWidth(); 
      this.setWindowWidth(); 
      if (this.$("li.mega-nav").length) { 
        this.prepareMegaNav(); 
      } 
      $(window).on("resize", (function(_this) { 
        return function() { 
          _this.setWindowWidth(); 
          if (_this.$("li.mega-nav").length) { 
            _this.prepareMegaNav(); 
          } 
          if (_this.$el.hasClass("mobile-visible") && _this.windowWidth > 1020) { 
            _this.$el.removeClass("mobile-visible"); 
            return _this.resetHeights(); 
          } 
        }; 
      })(this)); 
      return $(".mobile-navigation-toggle").on("click", (function(_this) { 
        return function() { 
          return _this.toggleMobileNavigation(); 
        }; 
      })(this)); 
    }; 

    NavigationView.prototype.setWindowWidth = function() { 
      return this.windowWidth = document.documentElement.clientWidth; 
    }; 

    NavigationView.prototype.checkDropdownWidth = function() { 
      var i, item, itemOffset, len, ref, results; 
      ref = this.$(".navigation-first-tier > .has-dropdown"); 
      results = []; 
      for (i = 0, len = ref.length; i < len; i++) { 
        item = ref[i]; 
        item = $(item); 
        if (item.hasClass("mega-nav")) { 
          itemOffset = item.offset(); 
          if (item.find(".navigation-second-tier").length && itemOffset.left + 200 > this.windowWidth) { 
            item.addClass("alternate-drop"); 
          } 
          if (item.find(".navigation-third-tier").length && itemOffset.left + 400 > this.windowWidth) { 
            item.addClass("alternate-drop"); 
          } 
          if (item.find(".navigation-fourth-tier").length && itemOffset.left + 600 > this.windowWidth) { 
            results.push(item.addClass("alternate-drop")); 
          } else { 
            results.push(void 0); 
          } 
        } else { 
          results.push(void 0); 
        } 
      } 
      return results; 
    }; 

    NavigationView.prototype.toggleMobileNavigation = function() { 
      var firstTier, height; 
      if (!this.$el.hasClass("processed")) { 
        $(window).on("resize", (function(_this) { 
          return function() { 
            return _.debounce(function() { 
              if (_this.windowWidth > 1020) { 
                return _this.resetHeights(); 
              } 
            }, 500); 
          }; 
        })(this)); 
        this.$el.addClass("processed"); 
      } 
      firstTier = this.$(".navigation-first-tier"); 
      if (this.$el.hasClass("mobile-visible")) { 
        this.$el.removeClass("mobile-visible"); 
        return this.resetHeights(); 
      } else { 
        height = this.getHiddenHeight(firstTier); 
        firstTier.addClass("open"); 
        return setTimeout((function(_this) { 
          return function() { 
            _this.$el.addClass("mobile-visible"); 
            $(".mobile-navigation-toggle").addClass("active"); 
            return firstTier.height(height); 
          }; 
        })(this), 50); 
      } 
    }; 

    NavigationView.prototype.toggleMobileTier = function(e) { 
      var height, list, parent; 
      e.preventDefault(); 
      parent = $(e.target).closest(".has-dropdown, .mega-nav, .mega-nav-item, .has-children"); 
      list = parent.find("> ul"); 
      if (parent.hasClass("open")) { 
        height = list.height(); 
        list.parents("ul").css("height", "-=" + height); 
        list.find(".open").removeClass("open").find("> ul").height(""); 
        if (Modernizr.csstransitions) { 
          return list.height(0).one(this.transitionend, (function(_this) { 
            return function() { 
              return parent.removeClass("open"); 
            }; 
          })(this)); 
        } else { 
          return parent.removeClass("open"); 
        } 
      } else { 
        height = this.getHiddenHeight(list); 
        parent.addClass("open"); 
        list.height(height); 
        return list.parents("ul").css("height", "+=" + height); 
      } 
    }; 

    NavigationView.prototype.getHiddenHeight = function(elem) { 
      var height, temp; 
      temp = $(elem).clone().addClass("cloned-list").appendTo(this.$el); 
      height = temp.height(); 
      temp.remove(); 
      return height; 
    }; 

    NavigationView.prototype.resetHeights = function() { 
      var i, len, list, ref; 
      ref = this.$("ul"); 
      for (i = 0, len = ref.length; i < len; i++) { 
        list = ref[i]; 
        $(list).height("").parent().removeClass("open"); 
      } 
      return $(".mobile-navigation-toggle").removeClass("active"); 
    }; 

    NavigationView.prototype.prepareMegaNav = function() { 
      var bottomPosition, navigationWidth, toggleHeight, toggleTop; 
      this.megaNavDropdown = this.$(".mega-nav-dropdown"); 
      if (this.windowWidth > 1020) { 
        navigationWidth = this.$el.width(); 
        toggleTop = this.$(".mega-nav").position().top; 
        toggleHeight = this.$(".mega-nav").outerHeight(); 
        bottomPosition = toggleTop + toggleHeight - 1; 
        return this.megaNavDropdown.css({ 
          //top: bottomPosition, 
          //width: 1330, 
          //marginLeft: -665 
        }); 
      } else { 
        return this.megaNavDropdown.css({ 
          top: "", 
          width: "", 
          marginLeft: "" 
        }); 
      } 
    }; 

    NavigationView.prototype.setMegaNav = function(e) { 
      var firstTierHeight; 
      if (this.windowWidth < 1021) { 
        return; 
      } 
      firstTierHeight = this.megaNavDropdown.height(); 
      return this.megaNavDropdown.data("first-tier-height", firstTierHeight).height(firstTierHeight); 
    }; 

    NavigationView.prototype.resetMegaNav = function(e) { 
      if (this.windowWidth < 1021) { 
        return; 
      } 
      if (e && $(e.relatedTarget).closest(".mega-nav").length) { 
        return; 
      } 
      this.megaNavDropdown.height(this.megaNavDropdown.data("first-tier-height")); 
      return this.$(".active").removeClass("active"); 
    }; 

    NavigationView.prototype.changeTier = function(e) { 
      var currentHeight, nextTier, nextTierHeight; 
      if (this.windowWidth < 1021) { 
        return; 
      } 
      e.preventDefault(); 
      $(e.currentTarget).addClass("working"); 
      nextTier = $(e.currentTarget).next("ul"); 
      nextTierHeight = nextTier.outerHeight(); 
      currentHeight = this.megaNavDropdown.height(); 
      if (currentHeight < nextTierHeight) { 
        //this.megaNavDropdown.height(nextTierHeight); 
        this.megaNavDropdown.height(); 
      } else { 
        nextTier.css({ 
          "bottom": 0 
        }); 
      } 
      return $(e.currentTarget).removeClass("working").addClass("active"); 
    }; 

    NavigationView.prototype.previousTier = function(e) { 
      var previousTierHeight; 
      if ($(e.currentTarget).hasClass("current-tier")) { 
        return; 
      } 
      if ($(e.currentTarget).hasClass("first-tier")) { 
        this.$(".active").removeClass("active"); 
        this.megaNavDropdown.height(this.megaNavDropdown.data("first-tier-height")); 
      } else { 
        $(e.currentTarget).closest("ul").siblings(".active").removeClass("active"); 
        previousTierHeight = $(e.currentTarget).closest(".mega-nav-second-tier").outerHeight(); 
        this.megaNavDropdown.height(previousTierHeight); 
      } 
      if (!this.$(".active").length) { 
        return this.resetMegaNav(); 
      } 
    }; 

    return NavigationView; 

  })(Backbone.View); 

}).call(this); 

(function() { 
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; }, 
      hasProp = {}.hasOwnProperty; 

  window.SidebarView = (function(superClass) { 
    extend(SidebarView, superClass); 

    function SidebarView() { 
      return SidebarView.__super__.constructor.apply(this, arguments); 
    } 

    SidebarView.prototype.events = { 
      "click .has-children > a": "toggleDropdown" 
    }; 

    SidebarView.prototype.initialize = function() {}; 

    SidebarView.prototype.toggleDropdown = function(e) { 
      if (document.documentElement.clientWidth < 721) { 
        e.preventDefault(); 
        $(e.target).parent().toggleClass("open"); 
        return false; 
      } 
    }; 

    return SidebarView; 

  })(Backbone.View); 

}).call(this); 

(function() { 
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; }, 
      hasProp = {}.hasOwnProperty; 

  window.FooterView = (function(superClass) { 
    extend(FooterView, superClass); 

    function FooterView() { 
      return FooterView.__super__.constructor.apply(this, arguments); 
    } 

    FooterView.prototype.events = {}; 

    FooterView.prototype.initialize = function() { 
      this.instagramToken = Pacific.settings["footer-instagram-access-token"]; 
      if (this.$(".footer-instagram").length && this.instagramToken.length) { 
        this.count = "3" * 1; 
        this.fetchInstagramPhotos(); 
      } 
      if (this.$(".footer-tweet").length) { 
        return this.fetchTweets(); 
      } 
    }; 

    FooterView.prototype.fetchInstagramPhotos = function() { 
      var url; 
      if (Pacific.settings["footer-instagram-use-tag"]) { 
        url = "https://api.instagram.com/v1/tags//media/recent?access_token=" + this.instagramToken + "&count=" + this.count + "&callback=?"; 
      } else { 
        url = "https://api.instagram.com/v1/users/self/media/recent?access_token=" + this.instagramToken + "&count=" + this.count + "&callback=?"; 
      } 
        return $.ajax(url, { 
        type: "GET", 
          dataType: "jsonp", 
            timeout: 10000, 
              error: (function(_this) { 
                return function(jqXHR, textStatus) { 
                  _this.$(".footer-instagram").hide(); 
                  console.log("Instagram Error: " + textStatus); 
                  if (textStatus === "timeout") { 
                    return console.log("A timeout error means that either the API is down or the merchant provided an incorrect User ID causing a 404."); 
                  } 
                }; 
              })(this), 
                success: (function(_this) { 
                  return function(query) { 
                    var i, j, len, photo, ref, results; 
                    if (_this.count === 3) { 
                      i = 2; 
                    } else { 
                      i = 5; 
                    } 
                    if (query.meta.code === 200) { 
                      ref = query.data.slice(0, +i + 1 || 9e9); 
                      results = []; 
                      for (j = 0, len = ref.length; j < len; j++) { 
                        photo = ref[j]; 
                        results.push(_this.$(".footer-instagram-photos").append("<a class='footer-instagram-photo' href='" + photo.link + "' target='_blank'><img alt='' src='" + photo.images.standard_resolution.url + "'></a>")); 
                      } 
                      return results; 
                    } else { 
                      _this.$(".footer-instagram").hide(); 
                      return console.log("Instagram Error: " + query.meta.error_message); 
                    } 
                  }; 
                })(this) 
      }); 
    }; 

    FooterView.prototype.fetchTweets = function() { 
      var config; 
      config = { 
        "id": "", 
        "maxTweets": 1, 
        "enableLinks": true, 
        "showUser": true, 
        "showTime": true, 
        "showRetweet": Pacific.settings["footer-twitter-retweets"], 
        "customCallback": this.renderTweets, 
        "showInteraction": false 
      }; 
      return twitterFetcher.fetch(config); 
    }; 

    FooterView.prototype.renderTweets = function(tweets) { 
      if (tweets.length) { 
        return this.$(".footer-tweet").append(tweets[0]); 
      } else { 
        return console.log("No tweets to display. Most probably cause is an incorrectly entered Widget ID."); 
      } 
    }; 

    return FooterView; 

  })(Backbone.View); 

}).call(this); 

(function() { 
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; }, 
      hasProp = {}.hasOwnProperty; 

  window.AccountView = (function(superClass) { 
    extend(AccountView, superClass); 

    function AccountView() { 
      return AccountView.__super__.constructor.apply(this, arguments); 
    } 

    AccountView.prototype.events = { 
      "click .delete-address": "deleteAddress", 
      "click .edit-address": "editAddress", 
      "click .cancel-edit": "cancelEditing", 
      "click .toggle-new-address": "toggleNewAddress", 
      "click .toggle-forgetfulness span": "recoverPassword" 
    }; 

    AccountView.prototype.initialize = function() { 
      if ($(document.body).hasClass("template-customers-addresses")) { 
        this.prepareAddresses(); 
      } 
      if ($(document.body).hasClass("template-customers-login")) { 
        this.checkForReset(); 
      } 
      if (window.location.hash === "#recover") { 
        return this.recoverPassword(); 
      } 
    }; 

    AccountView.prototype.recoverPassword = function() { 
      this.$(".recover-password").toggle(); 
      return this.$(".customer-login").toggle(); 
    }; 

    AccountView.prototype.checkForReset = function() { 
      if ($(".reset-check").data("successful-reset") === true) { 
        return $(".successful-reset").show(); 
      } 
    }; 

    AccountView.prototype.prepareAddresses = function() { 
      var address, addressID, addresses, i, len, results; 
      new Shopify.CountryProvinceSelector("address-country", "address-province", { 
        hideElement: "address-province-container" 
      }); 
      addresses = this.$(".customer-address"); 
      if (addresses.length) { 
        results = []; 
        for (i = 0, len = addresses.length; i < len; i++) { 
          address = addresses[i]; 
          addressID = $(address).data("address-id"); 
          results.push(new Shopify.CountryProvinceSelector("address-country-" + addressID, "address-province-" + addressID, { 
            hideElement: "address-province-container-" + addressID 
          })); 
        } 
        return results; 
      } 
    }; 

    AccountView.prototype.deleteAddress = function(e) { 
      var addressID; 
      addressID = $(e.target).parents("[data-address-id]").data("address-id"); 
      return Shopify.CustomerAddress.destroy(addressID); 
    }; 

    AccountView.prototype.editAddress = function(e) { 
      var addressID, modalContent; 
      addressID = $(e.target).parents("[data-address-id]").data("address-id"); 
      modalContent = new ModalContent({ 
        title: false, 
        message: false 
      }); 
      return new ModalView({ 
        model: modalContent, 
        el: this.$(".modal-wrapper[data-address-id='" + addressID + "']") 
      }); 
    }; 

    AccountView.prototype.cancelEditing = function(e) { 
      var addressID; 
      addressID = $(e.target).parents("[data-address-id]").data("address-id"); 
      $(".customer-address[data-address-id='" + addressID + "']").removeClass("editing"); 
      return $(".customer-address-edit-form[data-address-id='" + addressID + "']").removeClass("show"); 
    }; 

    AccountView.prototype.toggleNewAddress = function() { 
      this.$(".add-new-address").toggle(); 
      return this.$(".customer-new-address").toggleClass("show"); 
    }; 

    return AccountView; 

  })(Backbone.View); 

}).call(this); 

(function() { 
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; }, 
      hasProp = {}.hasOwnProperty; 

  window.CartView = (function(superClass) { 
    extend(CartView, superClass); 

    function CartView() { 
      return CartView.__super__.constructor.apply(this, arguments); 
    } 

    CartView.prototype.events = { 
      "change .item-quantity-display": "checkQuantity",      
      "click .cart-item-decrease": "updateQuantity", 
      "click .cart-item-increase": "updateQuantity", 
      "click .remove span": "removeProduct", 
      "click .cart-undo": "undoRemoval", 
      "change .cart-instructions textarea": "saveSpecialInstructions", 
      "click .cart-item-upload": "showFile", 
      "click .get-rates": "onGetRates" 
    }; 

    CartView.prototype.initialize = function() { 
      this.transitionend = (function(transition) { 
        var transEndEventNames; 
        transEndEventNames = { 
          "-webkit-transition": "webkitTransitionEnd", 
          "-moz-transition": "transitionend", 
          "-o-transition": "oTransitionEnd", 
          transition: "transitionend" 
        }; 
        return transEndEventNames[transition]; 
      })(Modernizr.prefixed("transition")); 
      this.savedProducts = []; 
      if (Pacific.settings["cart-shipping-calculator"] && Shop.requiresShipping) { 
        this.shippingCalculator(); 
        if (Shop.customerLoggedIn && Shop.customerAddress.country.length && Shop.customerAddress.zip.length) { 
          this.calculateShipping(true); 
        } 
        return Shopify.onError = (function(_this) { 
          return function(XMLHttpRequest) { 
            return _this.handleErrors(XMLHttpRequest); 
          }; 
        })(this); 
      } 
    }; 

    CartView.prototype.saveSpecialInstructions = function() { 
      var newNote; 
      newNote = $(".cart-instructions textarea").val(); 
      return Shopify.updateCartNote(newNote, function(cart) {}); 
    }; 

    CartView.prototype.checkQuantity = function(e) { 
      var Quantity1, inventory, alertContent,modalContent, newQuantity,quantity_less,Quantity, productPrice, productQuantity, productRow, variant, MOQ; 
      productRow = $(e.target).parents("tr"); 
      productQuantity = productRow.find(".item-quantity-display"); 
      Quantity = parseInt(productQuantity.val()); 

      inventory = parseInt(productRow.find(".item-quantity-display").data("max"), 10); 
      MOQ = parseInt(productRow.find(".item-quantity-display").data("moq"),10); 
       /* moq inline message */
      if (Quantity < MOQ){ 
        productQuantity.val(MOQ); 
       // alert("Minimum Quantity for this item is " + MOQ); 
         $("#moq_id_cart").html("Minimum Quantity for this item is " + MOQ ).show();       
         $("#max_id_cart").html("Sorry, we only have " + inventory + " in stock").hide();
        Quantity=MOQ; 
      } else{    
          Quantity1 = Quantity - 1; 
          productQuantity.val(Quantity1); 
         $("#moq_id_cart").html("Minimum Quantity for this item is " + MOQ ).hide();
         $("#max_id_cart").html("Sorry, we only have " + inventory + " in stock").hide();
          
        }

      if(Quantity > inventory){	 
        productQuantity.val(inventory); 
       // alert("Sorry, we only have " + inventory + " in stock");  
       $("#max_id_cart").html("Sorry, we only have " + inventory  + " in stock").show();
         $("#moq_id_cart").html("Minimum Quantity for this item is " + MOQ ).hide();
        Quantity=inventory; 
      }   
      productPrice = productRow.find(".cart-item-total .money"); 
      variant = productRow.data("variant"); 
      inventory = parseInt(productRow.find(".cart-item-quantity").data("max"), 10); 
      return Shopify.changeItem(variant, Quantity, (function(_this) { 
        return function(cart) { 
          var i, item, len, newProductPrice, ref; 
          ref = cart.items; 
          for (i = 0, len = ref.length; i < len; i++) { 
            item = ref[i]; 
            if (item.id === variant) { 
              newProductPrice = Shopify.formatMoney(item.line_price, Shop.moneyFormat); 
              productPrice.html(newProductPrice); 
              productRow.find(".cart-item-quantity-display").val(item.quantity); 
            } 
          } 
          return _this.updateCart(cart); 
        }; 
      })(this)); 

    }; 

    /* CartView.prototype.updateQuantity = function(e) { 
      var inventory, modalContent, newQuantity, quantity_less, oldQuantity, productPrice, productQuantity, productRow, variant, MOQ; 
      productRow = $(e.target).parents("tr"); 
      productQuantity = productRow.find(".cart-item-quantity-display"); 
      oldQuantity = parseInt(productQuantity.val()); 
      inventory = parseInt(productRow.find(".cart-item-quantity").data("max"), 10); 
      MOQ = productRow.find(".cart-item-quantity").data("moq"); 
      //if (Pacific.settings["disable-ajax"] || Pacific.settings["enable-currency-switcher"]) { 
       if ($(e.target).hasClass("cart-item-increase")) { 
         newQuantity = oldQuantity + 1; 
        if(newQuantity > inventory) 
         { 
         alert('We only have ' + inventory + ' of this item in stock'); 
         productQuantity.val(inventory); 
         } 
        else 
         // newQuantity = oldQuantity + 1; 
          productQuantity.val(newQuantity);          
        } 
        if ($(e.target).hasClass("cart-item-decrease")) { 
          if(oldQuantity === 0) 
          { 
            newQuantity = 0; 
          } 
          else 
          { 
          newQuantity = oldQuantity - 1; 
           if(newQuantity >= MOQ){ 
              productQuantity.val(newQuantity); 
           } 
           else{             
            alert('Minimum order quantity for this item ' + MOQ ); 
            productQuantity.val(oldQuantity); 
            } 
          } 
       } 
        //return; 
      //} 
      productPrice = productRow.find(".cart-item-total .money"); 
      variant = productRow.data("variant"); 
      inventory = parseInt(productRow.find(".cart-item-quantity").data("max"), 10); 
    /*  if ($(e.target).hasClass(".cart-item-quantity-display")) { 
        newQuantity = productQuantity; 
      } else if ($(e.target).hasClass("cart-item-increase")) { 
        newQuantity = oldQuantity + 1; 
      } else { 
        newQuantity = oldQuantity - 1; 
      } 
      if (newQuantity === 0) { 
        this.removeProduct(null, variant); 
        return; 
      } 
      if (newQuantity > inventory) { 
        modalContent = new ModalContent({ 
          title: "Not Available", 
          message: "<p>Sorry, we only have " + inventory + " in stock.</p>", 
          button: "Okay" 
        }); 
        new ModalView({ 
          model: modalContent, 
          el: this.$(".modal-wrapper") 
        }); 
      } 


       return Shopify.changeItem(variant, newQuantity, (function(_this) { 
        return function(cart) { 
          var i, item, len, newProductPrice, ref; 
          ref = cart.items; 
          for (i = 0, len = ref.length; i < len; i++) { 
            item = ref[i]; 
            if (item.id === variant) { 
              newProductPrice = Shopify.formatMoney(item.line_price, Shop.moneyFormat); 
              productPrice.html(newProductPrice); 
              productRow.find(".cart-item-quantity-display").val(item.quantity); 
            } 
          } 
          return _this.updateCart(cart); 
        }; 
      })(this)); 
    }; 
*/ 


    CartView.prototype.updateQuantity = function(e) { 
      var inventory, modalContent, newQuantity,quantity_less,tax,lineprice, oldQuantity, productPrice, productQuantity, productRow, variant, MOQ; 
      productRow = $(e.target).parents("tr"); 
      productQuantity = productRow.find(".cart-item-quantity-display"); 
      oldQuantity = parseInt(productQuantity.val()); 
      inventory = parseInt(productRow.find(".cart-item-quantity").data("max"), 10); 
      tax = productRow.find(".cart-item-quantity").data("tax"); 
      lineprice= productRow.find(".cart-item-quantity").data("lineprice"); 
      MOQ = productRow.find(".cart-item-quantity").data("moq"); 
      if ($(e.target).hasClass("cart-item-increase")) {  
        newQuantity = oldQuantity + 1; 
         /* moq inline message */
          if(newQuantity > inventory) 
        { 
          //alert("Sorry, we only have " + inventory + " in stock"); 
           $("#max_id_cart").html("Sorry, we only have " + inventory  + " in stock").show();
          $("#moq_id_cart").html("Minimum order quantity for this item " + MOQ ).hide();
          productQuantity.val(inventory); 

        } 
        else {   
          productQuantity.val(newQuantity); 
           $("#max_id_cart").html("Sorry, we only have " + inventory  + " in stock").hide();
          $("#moq_id_cart").html("Minimum order quantity for this item" + MOQ ).hide();
        }
        /*if(newQuantity > inventory) 
        { 
          alert("Sorry, we only have " + inventory + " in stock"); 
          productQuantity.val(inventory); 

        } 
        else {   
          productQuantity.val(newQuantity); 
        } */
      } 
      if ($(e.target).hasClass("cart-item-decrease")) { 

       /* if(oldQuantity === MOQ){ 

          alert("Minimum Quantity for this"+MOQ); 
          newQuantity=oldQuantity; 
          //              productQuantity.val(MOQ); 
        } 
        else{    
          newQuantity = oldQuantity - 1; 
          productQuantity.val(newQuantity);            
        } */
        
         if(oldQuantity === MOQ){ 

          //alert("Minimum Quantity for this"+MOQ); 
           $("#moq_id_cart").html("Minimum Quantity for this " + MOQ ).show();
         $("#max_id_cart").html("Sorry, we only have " + inventory + " in stock").hide();
          newQuantity=oldQuantity; 
          //              productQuantity.val(MOQ); 
        } 
        else{    
          newQuantity = oldQuantity - 1; 
          productQuantity.val(newQuantity);
         $("#moq_id_cart").html("Minimum Quantity for this " + MOQ ).hide();
         $("#max_id_cart").html("Sorry, we only have " + inventory + " in stock").hide();
        } 
        
        
      } 
 
      var lineprice1,cart_total_value; 
      productPrice = productRow.find(".cart-item-total .money"); 
      variant = productRow.data("variant"); 
      inventory = parseInt(productRow.find(".cart-item-quantity").data("max"), 10); 
      return Shopify.changeItem(variant, newQuantity, (function(_this) { 
        return function(cart) { 
          var i, item, len, newProductPrice, ref, f, tag_length,  current_tag, taxed_value, tax_percentage; 
          ref = cart.items; 
          cart_total_value=0; 
          for (i = 0, len = ref.length; i < len; i++) { 
            item = ref[i]; 

            lineprice1= $(e.target).parents("tbody").children("tr:eq("+i+")").find(".cart-item-quantity").data("lineprice"); 

            cart_total_value=cart_total_value+(lineprice1*item.quantity); 
            if (item.id === variant) { 
              taxed_value=lineprice*item.quantity; 
              //newProductPrice = Shopify.formatMoney(taxed_value, Shop.moneyFormat); 
              newProductPrice = Shopify.formatMoney(item.line_price, Shop.moneyFormat); 
              productPrice.html(newProductPrice); 
              productRow.find(".cart-item-quantity-display").val(item.quantity); 
            } 
          } 
          return _this.updateCart(cart); 
          //return _this.updateCart1(cart,cart_total_value); 
        }; 
      })(this));      
    }; 

    CartView.prototype.removeProduct = function(e, variant) { 
      var itemRow, itemRowContents, productTitle, productURL, showUndo; 
      if (variant) { 
        itemRow = $(".variant-" + variant); 
      } else { 
        variant = $(e.target).parents("tr").data("variant"); 
        itemRow = $(e.target).parents("tr"); 
      } 
      itemRowContents = itemRow.find("td"); 
      productTitle = itemRow.data("title"); 
      productURL = itemRow.data("url"); 
      this.savedProducts[variant] = { 
        "id": variant, 
        "content": itemRowContents, 
        "quantity": itemRow.find("td.quantity input").val() 
      }; 
      showUndo = (function(_this) { 
        return function() { 
          var itemRemovedText; 
          itemRemovedText = "{{ item_title }} has be removed from your cart.".replace("{{ item_title }}", "<a href='" + productURL + "'>" + productTitle + "</a>"); 
          itemRow.html("<td colspan='5'>" + itemRemovedText + " <span class='cart-undo' data-variant='" + variant + "'>Undo?</span>"); 
                       return itemRow.removeClass("removing"); 
        }; 
      })(this); 
      return Shopify.removeItem(variant, (function(_this) { 
        return function(cart) { 
          if (Modernizr.csstransitions) { 
            itemRow.addClass("removing").one(_this.transitionend, function() { 
              return showUndo(); 
            }); 
          } else { 
            showUndo(); 
          } 
          return _this.updateCart(cart); 
        }; 
      })(this)); 
    }; 

    CartView.prototype.undoRemoval = function(e) { 
      var savedProduct, variant; 
      variant = $(e.target).data("variant"); 
      savedProduct = this.savedProducts[variant]; 
      $("tr.variant-" + variant).html(savedProduct.content); 
      return Shopify.addItem(variant, savedProduct.quantity, (function(_this) { 
        return function() { 
          return Shopify.getCart(function(cart) { 
            return _this.updateCart(cart); 
          }); 
        }; 
      })(this)); 
    }; 

    CartView.prototype.updateCart1 = function(cart,total) { 
      var cartCount, cartCountText, newTotal; 
      //newTotal = Shopify.formatMoney(cart.total_price, Shop.moneyFormat); 
      newTotal = Shopify.formatMoney(total, Shop.moneyFormat); 
      this.$(".cart-checkout .cart-price .money").html(newTotal); 
      cartCount = cart.item_count; 
      //cartCountText = cart.item_count === 1 ? "item" : "items"; 
      // $(".bag-count").text(cartCount); 
      // return $(".bag-text").text(cartCountText); 
      $(".count-bag").text("("+cartCount+")"); 
      return; 
    }; 

    CartView.prototype.updateCart = function(cart) { 
      var cartCount, cartCountText, newTotal; 
      newTotal = Shopify.formatMoney(cart.total_price, Shop.moneyFormat); 
      this.$(".cart-checkout .cart-price .money").html(newTotal); 
      cartCount = cart.item_count; 
      //cartCountText = cart.item_count === 1 ? "item" : "items"; 
      // $(".bag-count").text(cartCount); 
      // return $(".bag-text").text(cartCountText); 
      $(".count-bag").text("("+cartCount+")"); 
      return; 
    }; 

    CartView.prototype.showFile = function(e) { 
      var file, image, modalContent; 
      file = $(e.target).data("file"); 
      if (file.match(/(jpg|jpeg|png|gif)/)) { 
        image = "<img alt='' src='" + file + "'>"; 
        modalContent = new ModalContent({ 
          title: $(e.target).prev().text(), 
          message: image 
        }); 
        return new ModalView({ 
          model: modalContent, 
          el: this.$(".modal-wrapper") 
        }); 
      } 
    }; 

    CartView.prototype.shippingCalculator = function() { 
      var selectableOptions; 
      Shopify.Cart.ShippingCalculator.show({ 
        submitButton: "Calculate shipping", 
        submitButtonDisabled: "Calculating...", 
        customerIsLoggedIn: Shop.customerLoggedIn, 
        moneyFormat: Shop.moneyFormat 
      }); 
      selectableOptions = this.$(".cart-shipping-calculator select"); 
      setTimeout((function(_this) { 
        return function() { 
          var i, len, results, select; 
          results = []; 
          for (i = 0, len = selectableOptions.length; i < len; i++) { 
            select = selectableOptions[i]; 
            results.push(_this.updateShippingLabel(select)); 
          } 
          return results; 
        }; 
      })(this), 500); 
      return this.$(".cart-shipping-calculator select").change((function(_this) { 
        return function(e) { 
          var i, len, results, select; 
          results = []; 
          for (i = 0, len = selectableOptions.length; i < len; i++) { 
            select = selectableOptions[i]; 
            results.push(_this.updateShippingLabel(select)); 
          } 
          return results; 
        }; 
      })(this)); 
    }; 

    CartView.prototype.onGetRates = function() { 
      return this.calculateShipping(); 
    }; 

    CartView.prototype.calculateShipping = function(auto) { 
      var shippingAddress; 
      this.$(".get-rates").val("Calculating..."); 
                               if (auto) { 
        shippingAddress = Shop.customerAddress; 
      } else { 
        shippingAddress = {}; 
        shippingAddress.zip = this.$(".address-zip").val() || ""; 
        shippingAddress.country = this.$(".address-country").val() || ""; 
        shippingAddress.province = this.$(".address-province").val() || ""; 
      } 
      return Shopify.getCartShippingRatesForDestination(shippingAddress, function(rates) { 
        var address, feedback, firstRate, i, len, price, rate, rateValues, ratesFeedback, response, shippingCalculatorResponse; 
        address = shippingAddress.zip + ", " + shippingAddress.province + ", " + shippingAddress.country; 
        if (!shippingAddress.province.length) { 
          address = shippingAddress.zip + ", " + shippingAddress.country; 
        } 
        if (!shippingAddress.zip.length) { 
          address = shippingAddress.province + ", " + shippingAddress.country; 
        } 
        if (!(shippingAddress.province.length && shippingAddress.zip.length)) { 
          address = shippingAddress.country; 
        } 
        shippingCalculatorResponse = this.$(".cart-shipping-calculator-response"); 
        shippingCalculatorResponse.empty().append("<p class='shipping-calculator-response message'/><ul class='shipping-rates'/>"); 
        ratesFeedback = $(".shipping-calculator-response"); 
        if (rates.length > 1) { 
          firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price); 
          feedback = "There are {{ number_of_rates }} shipping rates available for {{ address }}, starting at {{ rate }}.".replace("{{ address }}", address).replace("{{ number_of_rates }}", rates.length).replace("{{ rate }}", "<span class='money'>" + firstRate + "</span>"); 
          ratesFeedback.html(feedback); 
        } else if (rates.length === 1) { 
          response = "There is one shipping rate available for {{ address }}.".replace("{{ address }}", address); 
          ratesFeedback.html(response); 
        } else { 
          ratesFeedback.html("We do not ship to this destination."); 
                             } 
                             for (i = 0, len = rates.length; i < len; i++) { 
            rate = rates[i]; 
            price = Shopify.Cart.ShippingCalculator.formatRate(rate.price); 
            rateValues = "{{ rate_title }} at {{ rate }}".replace("{{ rate_title }}", rate.name).replace("{{ rate }}", "<span class='money'>" + price + "</span>"); 
            this.$(".shipping-rates").append("<li>" + rateValues + "</li>"); 
          } 
          return this.$(".get-rates").val("Calculate shipping"); 
                                          }); 
        }; 

        CartView.prototype.handleErrors = function(errors) { 
          var errorMessage; 
          errorMessage = $.parseJSON(errors.responseText); 
          errorMessage = "Error: zip / postal code {{ error_message }}".replace("{{ error_message }}", errorMessage.zip); 
          this.$(".cart-shipping-calculator-response").html("<p class='error'>" + errorMessage + "</p>"); 
          return this.$(".get-rates").val("Calculate shipping"); 
                                          }; 

                                          CartView.prototype.updateShippingLabel = function(select) { 
            var selectedOption; 
            if (select) { 
              select = $(select); 
              selectedOption = select.find("option:selected").val(); 
              if (!selectedOption) { 
                selectedOption = select.prev(".selected-text").data("default"); 
              } 
              select.prev(".selected-text").text(selectedOption); 
              return setTimeout((function(_this) { 
                return function() { 
                  if (select.attr("name") === "address[country]") { 
                    return _this.updateShippingLabel(_this.$("#address_province")); 
                  } 
                }; 
              })(this), 500); 
            } 
          }; 

          return CartView; 

        })(Backbone.View); 

      }).call(this); 

      (function() { 
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; }, 
            hasProp = {}.hasOwnProperty; 

        window.ModalContent = (function(superClass) { 
          extend(ModalContent, superClass); 

          function ModalContent() { 
            return ModalContent.__super__.constructor.apply(this, arguments); 
          } 

          ModalContent.prototype.defaults = { 
            title: "", 
            message: "", 
            button: false 
          }; 

          return ModalContent; 

        })(Backbone.Model); 

        window.ModalView = (function(superClass) { 
          extend(ModalView, superClass); 

          function ModalView() { 
            return ModalView.__super__.constructor.apply(this, arguments); 
          } 

          ModalView.prototype.events = { 
            "click .modal-close": "closeModal" 
          }; 

          ModalView.prototype.initialize = function() { 
            this.content = this.model.toJSON(); 
            this.body = $(document.body); 
            this.transitionend = (function(transition) { 
              var transEndEventNames; 
              transEndEventNames = { 
                "-webkit-transition": "webkitTransitionEnd", 
                "-moz-transition": "transitionend", 
                "-o-transition": "oTransitionEnd", 
                transition: "transitionend" 
              }; 
              return transEndEventNames[transition]; 
            })(Modernizr.prefixed("transition")); 
            this.enterContent(); 
            return this.openModal(); 
          }; 

          ModalView.prototype.enterContent = function() { 
            if (this.content.title) { 
              this.$(".modal-title").text(this.content.title); 
            } 
            if (this.content.message) { 
              this.$(".modal-message").html(this.content.message); 
            } 
            if (this.content.button) { 
              return this.$(".modal-message").append("<p><span class='modal-close button'>" + this.content.button + "</span></p>"); 
            } 
          }; 

          ModalView.prototype.centerModal = function() { 
            var modalContentHeight, modalContentWidth; 
            modalContentHeight = this.$(".modal-content").outerHeight(); 
            modalContentWidth = this.$(".modal-content").outerWidth(); 
            if (modalContentHeight > $(window).height()) { 
              this.$(".modal-content").css({ 
                marginTop: 0, 
                marginLeft: -(modalContentWidth / 2) 
              }); 
              return this.body.addClass("modal-overflow"); 
            } else { 
              this.$(".modal-content").css({ 
                marginTop: -(modalContentHeight / 2), 
                marginLeft: -(modalContentWidth / 2) 
              }); 
              return this.body.removeClass("modal-overflow"); 
            } 
          }; 

          ModalView.prototype.openModal = function() { 
            var checkImagesLoaded; 
            this.$el.addClass("active"); 
            setTimeout((function(_this) { 
              return function() { 
                return _this.$el.addClass("opening"); 
              }; 
            })(this), 20); 
            checkImagesLoaded = (function(_this) { 
              return function() { 
                return _this.$el.imagesLoaded(function() { 
                  _this.centerModal(); 
                  $(window).on("resize", _.debounce(_this.centerModal, 50)); 
                  return _this.$el.addClass("open"); 
                }); 
              }; 
            })(this); 
            if (Modernizr.csstransitions) { 
              this.$el.one(this.transitionend, (function(_this) { 
                return function() { 
                  return checkImagesLoaded(); 
                }; 
              })(this)); 
            } else { 
              checkImagesLoaded(); 
            } 
            return this.body.on("keyup.modal", (function(_this) { 
              return function(e) { 
                if (e && e.type === "keyup" && e.keyCode === 27) { 
                  return _this.closeModal(); 
                } 
              }; 
            })(this)); 
          }; 

          ModalView.prototype.closeModal = function() { 
            var finishClosing; 
            this.body.off("keyup.modal"); 
            this.$el.removeClass("open"); 
            this.$(".modal-content").one(this.transitionend, (function(_this) { 
              return function(e) { 
                return _this.$el.removeClass("opening"); 
              }; 
            })(this)); 
            finishClosing = (function(_this) { 
              return function() { 
                _this.$(".modal-content").unbind(); 
                _this.$el.unbind(); 
                _this.unbind(); 
                _this.body.removeClass("modal-overflow"); 
                return _this.$el.removeClass("active"); 
              }; 
            })(this); 
            if (Modernizr.csstransitions) { 
              this.$(".modal-content").one(this.transitionend, (function(_this) { 
                return function(e) { 
                  return _this.$el.removeClass("opening"); 
                }; 
              })(this)); 
              return this.$el.on(this.transitionend, (function(_this) { 
                return function(e) { 
                  if ($(e.target).hasClass("modal-wrapper")) { 
                    return finishClosing(); 
                  } 
                }; 
              })(this)); 
            } else { 
              this.$el.removeClass("opening"); 
              return finishClosing(); 
            } 
          }; 

          return ModalView; 

        })(Backbone.View); 

      }).call(this); 

      (function() { 
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; }, 
            hasProp = {}.hasOwnProperty; 

        window.CollectionView = (function(superClass) { 
          extend(CollectionView, superClass); 

          function CollectionView() { 
            return CollectionView.__super__.constructor.apply(this, arguments); 
          } 

          CollectionView.prototype.events = { 
            "change .collection-filter select": "updateFilter", 
            "change .collection-sorting select": "sortProducts", 
            "click .collection-remove-filter": "resetFilter", 
            "click .collection-description-more": "createModal", 
            "click .collection-sharing-toggle": "toggleSharing", 
            "mouseout .share-buttons": "toggleSharing" 
          }; 

          CollectionView.prototype.initialize = function() { 
            this.tagsWrapper = this.$(".collection-tags-wrapper"); 
            this.tags = this.tagsWrapper.find(".collection-tags"); 
            this.tagFilter = this.$(".collection-tags-apply"); 
            if ($("html").hasClass("lt-ie9") && this.$(".collection-header").length) { 
              this.verticallyAlignHeaderText(); 
            } 
            if (Pacific.settings["collection-filtering"]) { 
              this.filterProducts(); 
            } 
            if (Pacific.settings["collection-product-text-style"] === "overlay") { 
              this.verticallyAlignProductDetails(); 
            } 
            if (Pacific.settings["collection-layout-style"] === "masonry") { 
              return this.masonryLayout(); 
            } 
          }; 

          CollectionView.prototype.verticallyAlignHeaderText = function() { 
            var headerHeight; 
            headerHeight = this.$(".collection-details").height(); 
            return this.$(".collection-details").css({ 
              marginTop: -(headerHeight / 2) 
            }); 
          }; 

          CollectionView.prototype.verticallyAlignProductDetails = function() { 
            var detailsHeight, i, len, product, ref, results; 
            ref = this.$(".product-list-item"); 
            results = []; 
            for (i = 0, len = ref.length; i < len; i++) { 
              product = ref[i]; 
              detailsHeight = $(product).find(".product-list-item-details").height(); 
              results.push($(product).find(".product-list-item-details").css({ 
                marginTop: -(detailsHeight / 2) 
              })); 
            } 
            return results; 
          }; 

          CollectionView.prototype.toggleSharing = function(e) { 
            if (e.type === "mouseout") { 
              if ($(e.relatedTarget).closest(".share-buttons").length) { 
                return; 
              } 
            } 
            return this.$(".collection-sharing").toggleClass("active"); 
          }; 

          CollectionView.prototype.sortProducts = function(e) { 
            var Sorting, currentSearch, i, index, len, part, search, searchParts; 
            Sorting = {}; 
            Sorting.sort_by = this.$(".collection-sorting select").val(); 
            if ($(e.target).closest(".collection-sorting").hasClass("vendor-collection")) { 
              currentSearch = location.search; 
              searchParts = currentSearch.split("&"); 
              for (index = i = 0, len = searchParts.length; i < len; index = ++i) { 
                part = searchParts[index]; 
                if (part.indexOf("sort_by") !== -1) { 
                  searchParts.splice(index, 1); 
                } 
              } 
              search = searchParts.join("&"); 
              return location.search = search + "&" + (jQuery.param(Sorting)); 
            } else { 
              return location.search = jQuery.param(Sorting); 
            } 
          }; 

          CollectionView.prototype.masonryLayout = function() { 
            var products; 
            products = this.$(".collection-products"); 
            if (this.$(".product-list-item").length) { 
              return products.imagesLoaded((function(_this) { 
                return function() { 
                  var masonry; 
                  products.masonry({ 
                    transitionDuration: 0 
                  }); 
                  masonry = products.data("masonry"); 
                  masonry.on("layoutComplete", products.addClass("processed")); 
                  return masonry.off("layoutComplete"); 
                }; 
              })(this)); 
            } else { 
              return products.addClass("processed empty-collection"); 
            } 
          }; 

          CollectionView.prototype.filterProducts = function() { 
            var filter, i, len, ref, results, selectedText; 
            this.fallbackURL = this.$(".collection-filtering").data("fallback-url"); 
            ref = this.$(".collection-filter select"); 
            results = []; 
            for (i = 0, len = ref.length; i < len; i++) { 
              filter = ref[i]; 
              if ($(filter).val() !== "any") { 
                selectedText = $(filter).find("option:selected").text(); 
                results.push($(filter).prev().find("strong").text(selectedText)); 
              } else { 
                results.push(void 0); 
              } 
            } 
            return results; 
          }; 

          CollectionView.prototype.updateFilter = function(e) { 
            var filter, filterURL, i, len, newTags, ref, tag, tags; 
            newTags = []; 
            $(e.target).toggleClass("active"); 
            ref = this.$(".collection-filter select"); 
            for (i = 0, len = ref.length; i < len; i++) { 
              filter = ref[i]; 
              if ($(filter).val() !== "any") { 
                tag = $(filter).val(); 
                newTags.push(tag); 
              } 
            } 
            if (newTags.length) { 
              tags = newTags.join("+"); 
              filterURL = this.fallbackURL + "/" + tags + location.search; 
              return window.location.href = filterURL; 
            } else { 
              return this.resetFilter(); 
            } 
          }; 

          CollectionView.prototype.resetFilter = function() { 
            var fallback; 
            fallback = "" + this.fallbackURL + location.search; 
            return window.location.href = fallback; 
          }; 

          CollectionView.prototype.createModal = function() { 
            var modalContent; 
            modalContent = new ModalContent({ 
              "title": collectionJSON.title, 
              "message": collectionJSON.body_html 
            }); 
            return new ModalView({ 
              model: modalContent, 
              el: this.$(".modal-wrapper") 
            }); 
          }; 

          return CollectionView; 

        })(Backbone.View); 

      }).call(this); 

      (function() { 
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; }, 
            hasProp = {}.hasOwnProperty; 

        window.SlideshowView = (function(superClass) { 
          extend(SlideshowView, superClass); 

          function SlideshowView() { 
            return SlideshowView.__super__.constructor.apply(this, arguments); 
          } 

          SlideshowView.prototype.events = { 
            "click .previous-slide": "previousSlide", 
            "click .next-slide": "nextSlide", 
            "click .slideshow-pagination > span": "specificSlide", 
            "mouseenter": "pauseLoop", 
            "mouseleave": "startLoop" 
          }; 

          SlideshowView.prototype.initialize = function() { 
            this.navigation = this.$(".slideshow-navigation"); 
            this.pagination = this.$(".slideshow-pagination"); 
            this.setWindowWidth(); 
            this.setupSlides(); 
            return this.transitionend = (function(transition) { 
              var transEndEventNames; 
              transEndEventNames = { 
                "-webkit-transition": "webkitTransitionEnd", 
                "-moz-transition": "transitionend", 
                "-o-transition": "oTransitionEnd", 
                transition: "transitionend" 
              }; 
              return transEndEventNames[transition]; 
            })(Modernizr.prefixed("transition")); 
          }; 

          SlideshowView.prototype.setWindowWidth = function() { 
            return this.windowWidth = document.documentElement.clientWidth; 
          }; 

          SlideshowView.prototype.setupSlides = function() { 
            var paginationWidth; 
            this.slides = this.$(".slideshow-slide"); 
            this.slideCount = this.slides.length; 
            this.pagination.find("span:first").addClass("active"); 
            if (!Modernizr.csstransforms) { 
              paginationWidth = this.pagination.width(); 
              this.pagination.css({ 
                marginLeft: -(paginationWidth / 2) 
              }); 
            } 
            return this.$el.imagesLoaded((function(_this) { 
              return function() { 
                var i, image, imageHeight, j, len, ref, slide, slideContent, slideHeight, slideID, textHeight; 
                ref = _this.slides; 
                for (i = j = 0, len = ref.length; j < len; i = ++j) { 
                  slide = ref[i]; 
                  slide = $(slide); 
                  slideID = slide.attr("id"); 
                  image = slide.find(".slide-image"); 
                  imageHeight = image.height(); 
                  slide.data("height", imageHeight); 
                  slideHeight = _this.windowWidth <= 540 ? slide.height() : imageHeight; 
                  if (!Modernizr.csstransforms) { 
                    slideContent = slide.find(".slide-content"); 
                    textHeight = slideContent.height(); 
                    slideContent.css({ 
                      marginTop: -(textHeight / 2) 
                    }); 
                  } 
                  if (i === 0) { 
                    slide.addClass("active"); 
                    _this.$el.height(slideHeight); 
                    _this.navigation.css({ 
                      paddingTop: ((imageHeight - 48) / 2) + "px" 
                    }); 
                    _this.resetPaginationPosition(imageHeight); 
                  } 
                  if (i + 1 === _this.slideCount) { 
                    _this.$el.addClass("slides-ready"); 
                  } 
                } 
                $(window).on("resize", function() { 
                  _this.setWindowWidth(); 
                  return _this.resetSlideHeights(); 
                }); 
                if (Pacific.settings["slideshow-autoplay"]) { 
                  _this.delay = 4000; 
                  if (Pacific.settings["slideshow-autoplay-delay"].length) { 
                    _this.delay = parseInt(Pacific.settings["slideshow-autoplay-delay"], 10) * 1000; 
                  } 
                  return _this.startLoop(); 
                } 
              }; 
            })(this)); 
          }; 

          SlideshowView.prototype.resetSlideHeights = function() { 
            var image, imageHeight, j, len, ref, results, slide, slideHeight; 
            ref = this.slides; 
            results = []; 
            for (j = 0, len = ref.length; j < len; j++) { 
              slide = ref[j]; 
              slide = $(slide); 
              image = slide.find(".slide-image"); 
              imageHeight = image.height(); 
              slide.css("height", ""); 
              slide.data("height", imageHeight); 
              slideHeight = this.windowWidth <= 540 ? slide.height() : imageHeight; 
              if (slide.hasClass("active")) { 
                this.$el.height(slideHeight); 
                this.navigation.css({ 
                  paddingTop: ((imageHeight - 48) / 2) + "px" 
                }); 
                results.push(this.resetPaginationPosition(imageHeight)); 
              } else { 
                results.push(void 0); 
              } 
            } 
            return results; 
          }; 

          SlideshowView.prototype.resetPaginationPosition = function(height) { 
            if (this.windowWidth <= 540) { 
              return this.pagination.css({ 
                bottom: "auto", 
                top: height - 50 
              }); 
            } else { 
              return this.pagination.css({ 
                bottom: 0, 
                top: "auto" 
              }); 
            } 
          }; 

          SlideshowView.prototype.previousSlide = function(e) { 
            if (this.sliding) { 
              return; 
            } 
            this.showNewSlide("prev"); 
            return e.preventDefault(); 
          }; 

          SlideshowView.prototype.nextSlide = function(e) { 
            if (this.sliding) { 
              return; 
            } 
            this.showNewSlide("next"); 
            if (e) { 
              return e.preventDefault(); 
            } 
          }; 

          SlideshowView.prototype.specificSlide = function(e) { 
            var nextSlideID; 
            if (!$(e.currentTarget).hasClass("active")) { 
              nextSlideID = $(e.currentTarget).data("slide-id"); 
              return this.showNewSlide("next", nextSlideID); 
            } 
          }; 

          SlideshowView.prototype.updateSlidePagination = function(index) { 
            this.pagination.find(".active").removeClass("active"); 
            return this.pagination.find("> span").eq(index).addClass("active"); 
          }; 

          SlideshowView.prototype.showNewSlide = function(type, specificSlide) { 
            var activeSlide, called, direction, fallback, imageHeight, nextSlide, slideHeight, slideID; 
            this.sliding = true; 
            called = false; 
            if (this.slides.length === 1) { 
              this.sliding = false; 
              return; 
            } 
            direction = type === "next" ? "left" : "right"; 
            fallback = type === "next" ? "first" : "last"; 
            activeSlide = this.$(".slideshow-slide.active"); 
            nextSlide = specificSlide ? this.$("#" + specificSlide) : activeSlide[type](); 
            nextSlide = nextSlide.length ? nextSlide : this.slides[fallback](); 
            nextSlide.addClass(type); 
            nextSlide[0].offsetWidth; 
            activeSlide.addClass(direction); 
            nextSlide.addClass(direction); 
            if (Modernizr.csstransitions) { 
              nextSlide.one(this.transitionend, (function(_this) { 
                return function() { 
                  called = true; 
                  nextSlide.removeClass([type, direction].join(" ")).addClass("active"); 
                  activeSlide.removeClass(["active", direction].join(" ")); 
                  return _this.sliding = false; 
                }; 
              })(this)); 
              setTimeout((function(_this) { 
                return function() { 
                  if (!called) { 
                    return nextSlide.trigger(_this.transitionend); 
                  } 
                }; 
              })(this), 300 + 10); 
            } else { 
              nextSlide.removeClass([type, direction].join(" ")).addClass("active"); 
              activeSlide.removeClass(["active", direction].join(" ")); 
              this.sliding = false; 
            } 
            imageHeight = nextSlide.data("height"); 
            this.updateSlidePagination(nextSlide.index()); 
            this.resetPaginationPosition(imageHeight); 
            this.navigation.css({ 
              paddingTop: ((imageHeight - 48) / 2) + "px" 
            }); 
            slideHeight = this.windowWidth <= 720 ? nextSlide.height() : imageHeight; 
            slideID = nextSlide.attr('id'); 
            return this.$el.height(slideHeight).removeClass("showing-slide-" + (activeSlide.index() + 1)).addClass("showing-slide-" + (nextSlide.index() + 1)); 
          }; 

          SlideshowView.prototype.startLoop = function() { 
            if (Pacific.settings["slideshow-autoplay"]) { 
              if (!this.loop) { 
                this.loop = true; 
                return this.autoplay = setInterval((function(_this) { 
                  return function() { 
                    return _this.nextSlide(); 
                  }; 
                })(this), this.delay); 
              } 
            } 
          }; 

          SlideshowView.prototype.pauseLoop = function() { 
            this.loop = false; 
            return clearInterval(this.autoplay); 
          }; 

          return SlideshowView; 

        })(Backbone.View); 

      }).call(this); 

      (function() { 
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; }, 
            hasProp = {}.hasOwnProperty; 

        window.HomeView = (function(superClass) { 
          extend(HomeView, superClass); 

          function HomeView() { 
            return HomeView.__super__.constructor.apply(this, arguments); 
          } 

          HomeView.prototype.events = { 
            "click .home-video-play-button": "openVideo", 
            "keyup": "closeVideo" 
          }; 

          HomeView.prototype.initialize = function() { 
            var collection, feature, i, j, k, len, len1, len2, product, ref, ref1, ref2; 
            if (Pacific.settings["home-modules-order"].indexOf("A") > -1) { 
              new SlideshowView({ 
                el: this.$(".home-slideshow") 
              }); 
            } 
            if (this.$(".home-video").length) { 
              this.videoWrapper = this.$(".home-video-embed-wrapper"); 
              this.video = this.$(".home-video-embed"); 
              this.detachedVideo = null; 
            } 
            if (this.$(".home-featured-products").length && Pacific.settings["collection-product-text-style"] === "overlay") { 
              ref = this.$(".product-list-item"); 
              for (i = 0, len = ref.length; i < len; i++) { 
                product = ref[i]; 
                this.verticallyAlignContent($(product).find(".product-list-item-details")); 
              } 
            } 
            if ($("html").hasClass("lt-ie9")) { 
              this.centerVideoText(); 
              ref1 = this.$(".home-featured-collection"); 
              for (j = 0, len1 = ref1.length; j < len1; j++) { 
                collection = ref1[j]; 
                this.verticallyAlignContent($(collection).find(".home-featured-collection-content")); 
              } 
              ref2 = this.$(".home-feature"); 
              for (k = 0, len2 = ref2.length; k < len2; k++) { 
                feature = ref2[k]; 
                if ($(feature).find(".home-feature-content").length) { 
                  this.verticallyAlignContent($(feature).find(".home-feature-content")); 
                } 
              } 
            } 
            return this.transitionend = (function(transition) { 
              var transEndEventNames; 
              transEndEventNames = { 
                "-webkit-transition": "webkitTransitionEnd", 
                "-moz-transition": "transitionend", 
                "-o-transition": "oTransitionEnd", 
                transition: "transitionend" 
              }; 
              return transEndEventNames[transition]; 
            })(Modernizr.prefixed("transition")); 
          }; 

          HomeView.prototype.openVideo = function() { 
            this.videoWrapper.addClass("opening"); 
            if (this.detachedVideo) { 
              this.video.width(""); 
              this.detachedVideo.appendTo(this.video); 
            } else { 
              this.video.fitVids({ 
                customSelector: "iframe" 
              }); 
            } 
            this.verticallyCenterVideo(); 
            $(window).on("resize.video", (function(_this) { 
              return function() { 
                return _this.verticallyCenterVideo(); 
              }; 
            })(this)); 
            this.videoWrapper.on("click.video", (function(_this) { 
              return function() { 
                return _this.closeVideo(); 
              }; 
            })(this)); 
            return setTimeout((function(_this) { 
              return function() { 
                return _this.videoWrapper.addClass("open"); 
              }; 
            })(this), 20); 
          }; 

          HomeView.prototype.centerVideoText = function() { 
            var contentHeight, contentWidth, videoContent; 
            videoContent = this.$(".home-video-content"); 
            contentWidth = videoContent.outerWidth(); 
            contentHeight = videoContent.outerHeight(); 
            return videoContent.css({ 
              marginTop: -(contentHeight / 2), 
              marginLeft: -(contentWidth / 2) 
            }); 
          }; 

          HomeView.prototype.verticallyCenterVideo = function() { 
            var availableHeight, video, videoHeight, videoRatio, windowHeight; 
            this.video.css({ 
              marginTop: 0, 
              width: "100%" 
            }); 
            video = this.video.find(".fluid-width-video-wrapper"); 
            videoHeight = video.outerHeight(); 
            videoRatio = video.width() / videoHeight; 
            windowHeight = window.innerHeight || $(window).height(); 
            availableHeight = windowHeight - 60; 
            if (videoHeight > availableHeight) { 
              return this.video.removeClass("centered").css({ 
                marginTop: 0, 
                width: availableHeight * videoRatio 
              }); 
            } else { 
              return this.video.addClass("centered").css({ 
                marginTop: -(videoHeight / 2), 
                width: "100%" 
              }); 
            } 
          }; 

          HomeView.prototype.closeVideo = function(e) { 
            var detach; 
            if (!this.$(".home-video").length) { 
              return; 
            } 
            if (e && this.videoWrapper.hasClass("open")) { 
              if (e.which !== 27) { 
                return; 
              } 
            } 
            $(window).off("resize.video"); 
            this.videoWrapper.off("click.video"); 
            this.videoWrapper.removeClass("open"); 
            detach = (function(_this) { 
              return function() { 
                _this.detachedVideo = _this.video.find(".fluid-width-video-wrapper").detach(); 
                return _this.videoWrapper.removeClass("opening").off(_this.transitionend); 
              }; 
            })(this); 
            if (Modernizr.csstransitions) { 
              this.videoWrapper.on(this.transitionend, (function(_this) { 
                return function() { 
                  return detach(); 
                }; 
              })(this)); 
              return setTimeout((function(_this) { 
                return function() { 
                  if (_this.videoWrapper.hasClass("opening")) { 
                    return detach(); 
                  } 
                }; 
              })(this), 300); 
            } else { 
              return detach(); 
            } 
          }; 

          HomeView.prototype.verticallyAlignContent = function(content) { 
            var contentHeight; 
            content = $(content); 
            contentHeight = content.outerHeight(); 
            return content.css({ 
              marginTop: -(contentHeight / 2) 
            }); 
          }; 

          return HomeView; 

        })(Backbone.View); 

      }).call(this); 

      (function() { 
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; }, 
            hasProp = {}.hasOwnProperty; 

        window.ListCollectionsView = (function(superClass) { 
          extend(ListCollectionsView, superClass); 

          function ListCollectionsView() { 
            return ListCollectionsView.__super__.constructor.apply(this, arguments); 
          } 

          ListCollectionsView.prototype.events = {}; 

          ListCollectionsView.prototype.initialize = function() { 
            if ($("html").hasClass("lt-ie9")) { 
              return this.verticallyAlignDetails(); 
            } 
          }; 

          ListCollectionsView.prototype.verticallyAlignDetails = function() { 
            return this.$(".collections-list").imagesLoaded((function(_this) { 
              return function() { 
                var collection, collectionDetailsHeight, collectionsDetails, i, len, ref, results; 
                ref = _this.$(".collection-item"); 
                results = []; 
                for (i = 0, len = ref.length; i < len; i++) { 
                  collection = ref[i]; 
                  collectionsDetails = $(collection).find(".collection-item-details"); 
                  collectionDetailsHeight = collectionsDetails.height(); 
                  results.push(collectionsDetails.css({ 
                    marginTop: -(collectionDetailsHeight / 2) 
                  })); 
                } 
                return results; 
              }; 
            })(this)); 
          }; 

          return ListCollectionsView; 

        })(Backbone.View); 

      }).call(this); 

      (function() { 
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; }, 
            hasProp = {}.hasOwnProperty; 

        window.ImageZoomView = (function(superClass) { 
          extend(ImageZoomView, superClass); 

          function ImageZoomView() { 
            return ImageZoomView.__super__.constructor.apply(this, arguments); 
          } 

          ImageZoomView.prototype.events = { 
            "prepare-zoom": "prepareZoom", 
            "click": "toggleZoom", 
            "mouseout .product-zoom": "toggleZoom", 
            "mousemove .product-zoom": "zoomImage" 
          }; 

          ImageZoomView.prototype.initialize = function() { 
            this.zoomArea = this.$(".product-zoom"); 
            this.$el.imagesLoaded((function(_this) { 
              return function() { 
                return _this.prepareZoom(); 
              }; 
            })(this)); 
            return $(window).resize((function(_this) { 
              return function() { 
                return _this.prepareZoom(); 
              }; 
            })(this)); 
          }; 

          ImageZoomView.prototype.prepareZoom = function() { 
            var newImage, photoAreaHeight, photoAreaWidth; 
            photoAreaWidth = this.$el.width(); 
            photoAreaHeight = this.$el.height(); 
            newImage = new Image(); 
            $(newImage).on("load", (function(_this) { 
              return function() { 
                var ratio, ratios; 
                _this.zoomImageWidth = newImage.width; 
                _this.zoomImageHeight = newImage.height; 
                ratios = new Array(); 
                ratios[0] = _this.zoomImageWidth / photoAreaWidth; 
                ratios[1] = _this.zoomImageHeight / photoAreaHeight; 
                ratio = Math.max.apply(Math, ratios); 
                if (ratio < 1.4) { 
                  _this.$el.removeClass("zoom-enabled"); 
                } else { 
                  _this.$el.addClass("zoom-enabled"); 
                  return _this.zoomArea.css({ 
                    backgroundImage: "url(" + newImage.src + ")" 
                  }); 
                } 
              }; 
            })(this)); 
            return newImage.src = this.$("img").attr("src"); 
          }; 

          ImageZoomView.prototype.toggleZoom = function(e) { 
            if (this.$el.hasClass("zoom-enabled")) { 
              if (e.type === "mouseout") { 
                this.zoomArea.removeClass("active"); 
                return; 
              } 
              if (this.zoomArea.hasClass("active")) { 
                this.zoomArea.removeClass("active"); 
              } else { 
                this.zoomArea.addClass("active"); 
              } 
              return this.zoomImage(e); 
            } 
          }; 

          ImageZoomView.prototype.zoomImage = function(e) { 
            var bigImageOffset, bigImageX, bigImageY, mousePositionX, mousePositionY, newBackgroundPosition, ratioX, ratioY, zoomHeight, zoomWidth; 
            zoomWidth = this.zoomArea.width(); 
            zoomHeight = this.zoomArea.height(); 
            bigImageOffset = this.$el.offset(); 
            bigImageX = Math.round(bigImageOffset.left); 
            bigImageY = Math.round(bigImageOffset.top); 
            mousePositionX = e.pageX - bigImageX; 
            mousePositionY = e.pageY - bigImageY; 
            if (mousePositionX < zoomWidth && mousePositionY < zoomHeight && mousePositionX > 0 && mousePositionY > 0) { 
              if (this.zoomArea.hasClass("active")) { 
                ratioX = Math.round(mousePositionX / zoomWidth * this.zoomImageWidth - zoomWidth / 2) * -1; 
                ratioY = Math.round(mousePositionY / zoomHeight * this.zoomImageHeight - zoomHeight / 2) * -1; 
                if (ratioX > 0) { 
                  ratioX = 0; 
                } 
                if (ratioY > 0) { 
                  ratioY = 0; 
                } 
                if (ratioX < -(this.zoomImageWidth - zoomWidth)) { 
                  ratioX = -(this.zoomImageWidth - zoomWidth); 
                } 
                if (ratioY < -(this.zoomImageHeight - zoomHeight)) { 
                  ratioY = -(this.zoomImageHeight - zoomHeight); 
                } 
                newBackgroundPosition = ratioX + "px " + ratioY + "px"; 
                return this.zoomArea.css({ 
                  backgroundPosition: newBackgroundPosition 
                }); 
              } 
            } 
          }; 

          return ImageZoomView; 

        })(Backbone.View); 

      }).call(this); 

      (function() { 
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; }, 
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; }, 
            hasProp = {}.hasOwnProperty; 

        window.ProductView = (function(superClass) { 
          extend(ProductView, superClass); 

          function ProductView() { 
            this.selectCallback = bind(this.selectCallback, this); 
            return ProductView.__super__.constructor.apply(this, arguments); 
          } 

          ProductView.prototype.events = { 
            "change .product-options select": "updateVariantLabel", 
            "click .product-thumbnails img": "swapImage", 
            "submit .product-form": "addToCart" 
          }; 
 
          ProductView.prototype.initialize = function() { 
            this.product = window.productJSON; 
            this.variants = this.product.variants; 
            this.images = this.product.images; 
            this.minimumPriceArea = this.$(".product-price-minimum"); 
            this.googlePriceArea = this.$(".google-price-minimum"); 
            this.addingToCart = false; 
            if (this.$(".product-images").length) { 
              this.cacheImages(); 
            } 
            if (this.$(".product-form").length) { 
              this.setupSelectors(); 
            } 
            if (Pacific.settings["product-enable-zoom"] && this.$(".product-images").length) { 
              new ImageZoomView({ 
                el: this.$(".product-main-image") 
              }); 
            } 
            if (Pacific.settings["collection-product-text-style"] === "overlay" && this.$(".related-products").length) { 
              this.verticallyAlignProductDetails(); 
            } 
            return Shopify.onError = (function(_this) { 
              return function(XMLHttpRequest) { 
                return _this.handleErrors(XMLHttpRequest); 
              }; 
            })(this); 
          }; 

          ProductView.prototype.verticallyAlignProductDetails = function() { 
            var detailsHeight, j, len, product, ref, results; 
            ref = this.$(".related-products"); 
            results = []; 
            for (j = 0, len = ref.length; j < len; j++) { 
              product = ref[j]; 
              detailsHeight = $(product).find(".product-list-item-details-wrapper > div").height(); 
              results.push($(".product-list-item-details-wrapper > div").css({ 
                marginTop: -(detailsHeight / 2) 
              })); 
            } 
            return results; 
          }; 

          ProductView.prototype.switchCurrency = function(minimum, compare) { 
            var attribute, j, len, ref; 
            ref = this.minimumPriceArea[0].attributes; 
            for (j = 0, len = ref.length; j < len; j++) { 
              attribute = ref[j]; 
              if (attribute.name.indexOf("data-") > -1) { 
                this.minimumPriceArea.attr(attribute.name, ""); 
              } 
            } 
            this.minimumPriceArea.attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Shop.currency, Shopify.formatMoney(minimum, Shop.moneyFormat)).attr("data-currency", Shop.currency); 
            this.$(".product-price-compare").attr("data-currency-" + Shop.currency, Shopify.formatMoney(compare, Shop.moneyFormat)).attr("data-currency", Shop.currency); 
            return $(".currency-switcher").trigger("reset-currency"); 
          }; 

          ProductView.prototype.cacheImages = function() { 
            return Shopify.Image.preload(this.images, "1024x1024"); 
          }; 

          ProductView.prototype.swapImage = function(e, newImage) { 
            var mainImage; 
            newImage = e ? $(e.target).data("high-res") : newImage; 
            mainImage = this.$(".product-main-image img")[0]; 
            mainImage.src = newImage; 
            if (Pacific.settings["product-enable-zoom"]) { 
              return this.$(".product-main-image").trigger("prepare-zoom"); 
            } 
          }; 

          ProductView.prototype.setupSelectors = function() { 
            var i, j, len, ref, results, selector, value; 
            new Shopify.OptionSelectors("product-variants", { 
              product: window.productJSON, 
              onVariantSelected: this.selectCallback, 
              enableHistoryState: true 
            }); 
            if (this.variants.length === 1 && this.variants[0].title === "Default Title") { 
              return this.$(".product-options").addClass("no-options"); 
            } else { 
              if (this.product.options.length === 1 && this.product.options[0] !== "Title") { 
                this.$(".selector-wrapper").prepend("<label>" + this.product.options[0] + "</label>"); 
              } 
              ref = this.$(".selector-wrapper"); 
              results = []; 
              for (i = j = 0, len = ref.length; j < len; i = ++j) { 
                selector = ref[i]; 
                value = $(selector).find("select").val(); 
                //Created on JAN 2019 30   for multiple variants showing sku   
                var url_string = window.location.href; 
                var url = new URL(url_string); 
                var c = url.searchParams.get("variant"); 
                var sku_id="#"+c; 
                if(c==null) 
                { 
                  $(".sku_variant").hide(); 
                  $(".page-title sku_variant").css("display","block"); 
                  $(".sku_variant").hide().slice(0,1).show(); 
                  var tre= $(".sku_variant").text(); 
                  var count=0; 
                  $(".sku_variant").each(function() 
                                         { 
                    count++; 
                    if(count==1) 
                    { 
                      var default_attr= $(this).attr("sku_attrib"); 
                      var hand=$('.titles').text(); 
                      // alert(hand+''+req_sku); 
                      // var merge_title=hand+' ('+req_sku+')'; 
                      $("#product_title").val(hand+' SKU '+default_attr); 
                      $("#q_product_title").val(hand+' SKU '+default_attr); 
                      $("#sku").val(default_attr); 
                      $("#q_sku").val(default_attr); 
                    } 


                  });  
                } 
                else 
                { 
                  $(".sku_variant").hide(); 
                  $(".page-title sku_variant").css("display","block"); 
                  $(sku_id).hide().slice().show(); 
                  var tre= $(".sku_variant").text(); 
                  var count=0; 
                  $(".sku_variant").each(function() 
                                         { 
                    count++; 
                    if(count==1) 
                    { 
                      var default_attr= $(this).attr("sku_attrib"); 
                      var hand=$('.titles').text(); 
                      // alert(hand+''+req_sku); 
                      // var merge_title=hand+' ('+req_sku+')'; 
                      $("#product_title").val(hand+' SKU '+default_attr); 
                      $("#q_product_title").val(hand+' SKU '+default_attr); 
                      $("#sku").val(default_attr); 
                      $("#q_sku").val(default_attr); 
                    } 


                  }); 
                }          
                //Ended on JAN 2019 30  for multiple variants showing sku 



                results.push($(selector).find("select").wrap("<div class='select-wrapper' />").parent().prepend("<div class='select-text'>" + value + "</div>")); 
              } 
              return results; 
            } 
          }; 

          ProductView.prototype.updateVariantLabel = function(e, select) { 
            var selectedVariant; 
            select = e ? e.target : select; 
            select = $(select); 
            selectedVariant = select.find("option:selected").val(); 
            //Created on JAN 2019 30   for multiple variants showing sku 
            var url_string = window.location.href; 
            var url = new URL(url_string); 
            var c = url.searchParams.get("variant"); console.log('variant'+c);
            $('.buy_now').attr("data-vid",c);
            var sku_id="#"+c; 
            $(".sku_variant").hide(); 
            $(".page-title sku_variant").css("display","block"); 
            $(sku_id).hide().slice().show();      
            //Ended on JAN 2019 30  for multiple variants showing sku 
            var req_sku= $(sku_id).attr("sku_attrib"); 
            $("#sku").val(req_sku); 
            $("#q_sku").val(req_sku); 
            var hand=$('.titles').text(); 
            
            //Request Quote Function 
          	var p_sks= $(".last_s_sku:contains('"+req_sku+"')").text(); 
            if(p_sks==req_sku) 
            { 
              $(".add-to-cart").attr("disabled"); 
              var sku_price1 = $(sku_id).attr("sku_price"); 
              $(".add-to-cart").attr("disabled","true"); 
              $(".add-to-cart").css("background","#bfbfbf"); 
              // Buy now button 201907171030 
              $(".buy_now").attr("disabled","true"); 
              $(".buy_now").css("background","#bfbfbf");
              
              $(".iWishAdd1").show(); 
              $("#iwished").show(); 
			  $("#iwish").hide();               
    		   $("#delivery").hide(); 
              $(".stock_out").show(); 
              $(".iwishAdded").hide(); 
              $("#last-soldss").text("LAST SOLD AT "+sku_price1); 
            } 
            else 
            { 
              $("#delivery").show(); 
              $(".stock_out").hide(); 
              $(".iWishAdd1").hide(); 
               $("#iwished").hide(); 
              $(".iWishAdd").show();               
              $(".add-to-cart").css("background","#1990c6"); 
              $(".add-to-cart").removeAttr("disabled");           
              $("#last-soldss").text(""); 
              // buy now
              $(".buy_now").removeAttr("disabled"); 
   			  $(".buy_now").css("background","#093");
            } 
            //End Request Quote Function
            
            //   alert(hand+''+req_sku); 
            // var merge_title=hand+' ('+req_sku+')'; 
            $("#product_title").val(hand+' SKU '+req_sku); 
            $("#q_product_title").val(hand+' SKU '+req_sku); 


            return select.prev(".select-text").html(selectedVariant); 
          }; 

          ProductView.prototype.selectCallback = function(variant, selector) { 
            var addToCartButton, newImage; 
            var gsttax,tax,gst_price,n,comma_price;	 
            addToCartButton = this.$(".add-to-cart"); 
            gsttax = this.$(".product-gst-tax"); 
            tax = gsttax.data("tax"); 
            if (variant) { 
              this.$(".product-price").removeClass("unavailable"); 
              if (variant.available) { 
                addToCartButton.val("Add to cart").removeClass("disabled").prop("disabled", false); 
              } else { 
                addToCartButton.val("Out of Stock").addClass("disabled").prop("disabled", true); 
              } 
              this.minimumPriceArea.html(Shopify.formatMoney(variant.price, Shop.moneyFormat)); 
              n = String(variant.price/100); 
              // p = n.indexOf('.') 
              //comma_price=n.replace(/\d(?=(?:\d{3})+(?:\.|$))/g,(m, i) => p < 0 || i < p ? `${m},` : m); 
              this.googlePriceArea.html(n); 
              //this.minimumPriceArea.html(Shopify.formatMoney((((variant.price*tax)/100)+variant.price), Shop.moneyFormat)); 
              this.$(".product-price-compare").remove(); 
              if (variant.compare_at_price > variant.price) { 
                gst_price = (((variant.price*tax)/100)+variant.price); 
                this.minimumPriceArea.after("<span class='product-price-compare money' />"); 
                var percentage = (((variant.compare_at_price-variant.price)*100)/(variant.compare_at_price)); 
                //var percentage = (((variant.compare_at_price-gst_price)*100)/(variant.compare_at_price)); 
                var crt_percentage=percentage.toFixed(1); 
                this.$(".product-discount-percentage").html(Math.round(crt_percentage)+"% off"); 
                this.$(".product-price-compare").html(Shopify.formatMoney(variant.compare_at_price, Shop.moneyFormat)); 

                // this.$(".product-gst-tax").html(Shopify.formatMoney(gst_price,Shop.moneyFormat)+" with "+tax+"% GST."); 
                // this.$(".product-gst-tax").html("Extra "+tax+"% GST applicable."); 
                //COMMENTED ADDED 2018JAN30 GST ADDING 
                // this.$(".product-gst-tax").html("Inclusive of taxes"); 
                // ADDED 2018JAN30 ENDED GST ADDING 
                this.$(".product-gst-tax").html("Inclusive of "+ tax+"% GST"); 
              } 
              if (Pacific.settings["enable-currency-switcher"]) { 
                this.switchCurrency(variant.price, variant.compare_at_price); 
              } 
              if (variant && variant.featured_image) { 
                newImage = variant.featured_image; 
                if (this.$(".product-images").length) { 
                  return this.swapImage(null, newImage.src); 
                } 
              } 
            } else { 
              this.$(".product-price").addClass("unavailable"); 
              return addToCartButton.val("Unavailable").addClass("disabled").prop("disabled", true); 
            } 
          }; 

          ProductView.prototype.addToCart = function(e) { 
            if (Pacific.settings["disable-ajax"]) { 
              return; 
            } 
            e.preventDefault(); 
            if (!this.addingToCart) { 
              this.addingToCart = true; 
              this.$(".error-message").remove(); 
              return Shopify.addItemFromForm("product-form", (function(_this) { 
                return function(data) { 
                  return window.location.href = "/cart"; 
                }; 
              })(this)); 
            } 
          }; 

          ProductView.prototype.handleErrors = function(error) { 
            var max, message, target, variant, variantID; 
            if (error.responseJSON.message === "Cart Error") { 
              variantID = parseInt(this.$("#product-variants").val(), 10); 
              target = (function() { 
                var j, len, ref, results; 
                ref = this.product.variants; 
                results = []; 
                for (j = 0, len = ref.length; j < len; j++) { 
                  variant = ref[j]; 
                  if (variant.id === variantID) { 
                    results.push(variant); 
                  } 
                } 
                return results; 
              }).call(this); 
              max = target[0].inventory_quantity; 
              message = "Unable to add more than {{ stock }} to your cart.".replace("{{ stock }}", max); 
            } else { 
              message = "We were unable to add this product to your cart. Please try again later. Contact us if you continue to have issues.".replace("{{ stock }}", max); 
            } 
            return this.$(".product-form").append("<div class=\"error-message\">" + message + "</div>"); 
          }; 

          return ProductView; 

        })(Backbone.View); 

      }).call(this); 

      (function() { 
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; }, 
            hasProp = {}.hasOwnProperty; 

        window.RTEView = (function(superClass) { 
          extend(RTEView, superClass); 

          function RTEView() { 
            return RTEView.__super__.constructor.apply(this, arguments); 
          } 

          RTEView.prototype.events = { 
            "click .tabs li": "switchTabs", 
            "change .select-wrapper select": "updateOption" 
          }; 
 
          RTEView.prototype.initialize = function() { 
            var i, len, results, select, selects; 
            this.setupTabs(); 
            this.$el.fitVids({ 
              customSelector: "iframe" 
            }); 
            selects = this.$("select"); 
            results = []; 
            for (i = 0, len = selects.length; i < len; i++) { 
              select = selects[i]; 
              if (!$(select).parent(".select-wrapper").length) { 
                $(select).wrap('<div class="select-wrapper" />').parent().prepend("<span class='selected-text'></span>"); 
              } 
              results.push(this.updateOption(null, select)); 
            } 
            return results; 
          }; 

          RTEView.prototype.switchTabs = function(e) { 
            var position, tab; 
            tab = $(e.currentTarget); 
            position = tab.index(); 
            this.tabs.removeClass("active"); 
            this.tabsContent.removeClass("active"); 
            tab.addClass("active"); 
            this.tabsContent.eq(position).addClass("active"); 
            return e.preventDefault(); 
          }; 

          RTEView.prototype.setupTabs = function() { 
            this.tabs = this.$(".tabs > li"); 
            this.tabsContent = this.$(".tabs-content > li"); 
            this.tabs.first().addClass("active"); 
            return this.tabsContent.first().addClass("active"); 
          }; 

          RTEView.prototype.updateOption = function(e, selector) { 
            var newOption, select; 
            select = e ? $(e.target) : $(selector); 
            newOption = select.find("option:selected").text(); 
            return select.siblings(".selected-text").text(newOption); 
          }; 

          return RTEView; 

        })(Backbone.View); 

      }).call(this); 

      (function() { 
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; }, 
            hasProp = {}.hasOwnProperty; 

        window.ThemeView = (function(superClass) { 
          extend(ThemeView, superClass); 

          function ThemeView() { 
            return ThemeView.__super__.constructor.apply(this, arguments); 
          } 

          ThemeView.prototype.el = document.body; 

          ThemeView.prototype.initialize = function() { 
            var body; 
            body = $(document.body); 
            this.isHome = body.hasClass("template-index"); 
            this.isCollection = body.hasClass("template-collection"); 
            this.isListCollections = body.hasClass("template-list-collections"); 
            this.isProduct = body.hasClass("template-product"); 
            this.isCart = body.hasClass("template-cart"); 
            this.isPage = body.hasClass("template-page"); 
            this.isAccount = body.attr("class").indexOf("-customers-") > 0; 
            window.Pacific = {}; 
            return Pacific.settings = {"use-logo":true,"logo-height":"50","use-retina-logo":false,"body-background-use-image":false,"background-image-width":"","background-image-height":"","background-color":"#ffffff","body-text-color":"#000000","accent-color":"#c80000","heading-color":"#000000","meta-color":"#000000","error-color":"#c80000","border-color":"#d2d2d2","primary-button-background":"#009933","primary-button-color":"#ffffff","secondary-button-background":"#000000","secondary-button-color":"#ffffff","disabled-button-background":"#cccccc","disabled-button-color":"#888888","header-text-color":"#000000","header-promo-background-color":"#c80000","header-promo-text-color":"#ffffff","header-promo-link-color":"#f4ff00","footer-text-color":"#c80000","body-font":"Crimson, sans-serif","store-title-font":"Karla, sans-serif","store-title-font-weight":"700","store-title-font-small-caps":true,"heading-font":"Crimson, sans-serif","heading-font-weight":"700","heading-font-small-caps":true,"section-heading-font":"Crimson, sans-serif","section-heading-font-weight":"700","meta-font":"Crimson, sans-serif","meta-font-weight":"400","button-font":"Crimson, sans-serif","button-font-weight":"700","button-font-small-caps":true,"header-promo":false,"header-promo-text":"\u003ctitle\u003eBestomart Header Bar\t\u003c\/title\u003e     \u003cmeta charset=\"utf-8\"\u003e     \u003cmeta name=\"viewport\" content=\"width=device-width, initial-scale=1\"\u003e     \u003clink rel=\"stylesheet\" href=\"http:\/\/maxcdn.bootstrapcdn.com\/bootstrap\/3.3.5\/css\/bootstrap.min.css\"\u003e     \u003cscript src=\"https:\/\/ajax.googleapis.com\/ajax\/libs\/jquery\/1.11.3\/jquery.min.js\"\u003e\u003c\/script\u003e     \u003cscript src=\"http:\/\/maxcdn.bootstrapcdn.com\/bootstrap\/3.3.5\/js\/bootstrap.min.js\"\u003e\u003c\/script\u003e                 \u003cdiv class=\"container\"\u003e        \u003cdiv class=\"row\"\u003e \u003cdiv class=\"col-sm-3\" style=\"text-align:center\"\u003e          \u003cimg src=\"https:\/\/cdn.shopify.com\/s\/files\/1\/0970\/9798\/files\/phone-icon-white.png?4565986590485917655\" style=\"position:left\"\u003e+91 431 2500122        \u003c\/div\u003e      \u003cdiv class=\"col-sm-5\" style=\"text-align:center\"\u003e    \u003cimg src=\"https:\/\/cdn.shopify.com\/s\/files\/1\/0970\/9798\/files\/truck_white_small.png?16176229749143157688\"\u003eFree shipping for orders above Rs. 1000         \u003c\/div\u003e          \u003c\/div\u003e  \u003c\/div\u003e","mega-nav-item-text":"","mega-nav-1":true,"mega-nav-1-list":"electronics-electricals","mega-nav-1-use-image":true,"mega-nav-1-url":"\/collections\/electrical-electronics","mega-nav-2":true,"mega-nav-2-list":"hardwares-tools","mega-nav-2-use-image":true,"mega-nav-2-url":"\/collections\/tools-hardwares","mega-nav-3":true,"mega-nav-3-list":"test-measure","mega-nav-3-use-image":true,"mega-nav-3-url":"\/collections\/test-measure","mega-nav-4":true,"mega-nav-4-list":"security-safety","mega-nav-4-use-image":true,"mega-nav-4-url":"\/collections\/safety-security","mega-nav-5":true,"mega-nav-5-list":"office-supplies-it","mega-nav-5-use-image":true,"mega-nav-5-url":"\/collections\/office-supplies-it","mega-nav-6":false,"mega-nav-6-list":"","mega-nav-6-use-image":false,"mega-nav-6-url":"","mega-nav-7":false,"mega-nav-7-list":"","mega-nav-7-use-image":false,"mega-nav-7-url":"","mega-nav-8":false,"mega-nav-8-list":"","mega-nav-8-use-image":false,"mega-nav-8-url":"","mega-nav-item-text2":"DIY","mega-nav-21":true,"mega-nav-21-list":"diy","mega-nav-21-use-image":false,"mega-nav-21-url":"\/collections\/DIY","mega-nav-22":true,"mega-nav-22-list":"","mega-nav-22-use-image":true,"mega-nav-22-url":"","mega-nav-23":false,"mega-nav-23-list":"","mega-nav-23-use-image":false,"mega-nav-23-url":"","mega-nav-24":false,"mega-nav-24-list":"","mega-nav-24-use-image":false,"mega-nav-24-url":"","mega-nav-item-text3":"ACCESSORIES","mega-nav-31":true,"mega-nav-31-list":"accessories","mega-nav-31-use-image":false,"mega-nav-31-url":"\/collections\/Accessories","mega-nav-32":true,"mega-nav-32-list":"","mega-nav-32-use-image":true,"mega-nav-32-url":"","mega-nav-33":false,"mega-nav-33-list":"","mega-nav-33-use-image":false,"mega-nav-33-url":"","mega-nav-34":false,"mega-nav-34-list":"","mega-nav-34-use-image":false,"mega-nav-34-url":"","mega-nav-item-text4":"ELECTRICALS","mega-nav-41":true,"mega-nav-41-list":"electricals","mega-nav-41-use-image":false,"mega-nav-41-url":"\/collections\/Electricals","mega-nav-42":true,"mega-nav-42-list":"","mega-nav-42-use-image":true,"mega-nav-42-url":"","mega-nav-43":false,"mega-nav-43-list":"","mega-nav-43-use-image":false,"mega-nav-43-url":"","mega-nav-44":false,"mega-nav-44-list":"","mega-nav-44-use-image":false,"mega-nav-44-url":"","mega-nav-item-text5":"PACKAGING","mega-nav-51":true,"mega-nav-51-list":"packaging","mega-nav-51-use-image":false,"mega-nav-51-url":"\/collections\/Packaging","mega-nav-52":true,"mega-nav-52-list":"","mega-nav-52-use-image":true,"mega-nav-52-url":"","mega-nav-53":false,"mega-nav-53-list":"","mega-nav-53-use-image":false,"mega-nav-53-url":"","mega-nav-54":false,"mega-nav-54-list":"","mega-nav-54-use-image":false,"mega-nav-54-url":"","mega-nav-item-text6":"SAFETY","mega-nav-61":true,"mega-nav-61-list":"safety","mega-nav-61-use-image":false,"mega-nav-61-url":"\/collections\/Safety","mega-nav-62":true,"mega-nav-62-list":"","mega-nav-62-use-image":true,"mega-nav-62-url":"","mega-nav-63":false,"mega-nav-63-list":"","mega-nav-63-use-image":false,"mega-nav-63-url":"","mega-nav-64":false,"mega-nav-64-list":"","mega-nav-64-use-image":false,"mega-nav-64-url":"","mega-nav-item-text7":"TEST\/MEASURE","mega-nav-71":true,"mega-nav-71-list":"","mega-nav-71-use-image":false,"mega-nav-71-url":"\/collections\/Tools \u0026 Measure","mega-nav-72":true,"mega-nav-72-list":"","mega-nav-72-use-image":true,"mega-nav-72-url":"","mega-nav-73":false,"mega-nav-73-list":"","mega-nav-73-use-image":false,"mega-nav-73-url":"","mega-nav-74":false,"mega-nav-74-list":"","mega-nav-74-use-image":false,"mega-nav-74-url":"","mega-nav-item-text8":"TOOLS","mega-nav-81":true,"mega-nav-81-list":"hand-tools","mega-nav-81-use-image":false,"mega-nav-81-url":"\/collections\/hand-tools","mega-nav-82":true,"mega-nav-82-list":"power-tools","mega-nav-82-use-image":false,"mega-nav-82-url":"\/collections\/power-tools","mega-nav-83":true,"mega-nav-83-list":"","mega-nav-83-use-image":true,"mega-nav-83-url":"","mega-nav-84":false,"mega-nav-84-list":"","mega-nav-84-use-image":false,"mega-nav-84-url":"","mega-nav-item-text9":"WELDING","mega-nav-91":true,"mega-nav-91-list":"welding","mega-nav-91-use-image":false,"mega-nav-91-url":"\/collections\/Welding","mega-nav-92":true,"mega-nav-92-list":"","mega-nav-92-use-image":true,"mega-nav-92-url":"\/collections\/Welding","mega-nav-93":false,"mega-nav-93-list":"","mega-nav-93-use-image":false,"mega-nav-93-url":"","mega-nav-94":false,"mega-nav-94-list":"","mega-nav-94-use-image":false,"mega-nav-94-url":"","mega-nav-item-text10":"","mega-nav-101":true,"mega-nav-101-list":"","mega-nav-101-use-image":false,"mega-nav-101-url":"\/collections\/electrical","mega-nav-102":true,"mega-nav-102-list":"","mega-nav-102-use-image":false,"mega-nav-102-url":"\/collections\/electronics","mega-nav-103":true,"mega-nav-103-list":"","mega-nav-103-use-image":false,"mega-nav-103-url":"\/collections\/others","mega-nav-104":false,"mega-nav-104-list":"","mega-nav-104-use-image":false,"mega-nav-104-url":"","enable-currency-switcher":false,"currency-switcher-format":"money_with_currency_format","currency-switcher-supported-currencies":"INR","enable-sidebar":"not-home","sidebar-link-list-1":"","sidebar-link-list-2":"","sidebar-link-list-3":"","home-modules-order":"A-C-F-G-J","slideshow-layout":"content-width","slideshow-transition":"transition-slide","slideshow-navigation":true,"slideshow-pagination":true,"slideshow-autoplay":true,"slideshow-autoplay-delay":"4","show-slide-1":true,"slide-1-content-alignment":"center","slide-1-text-shadow":false,"slide-1-text-color":"#000000","slide-1-text-above":"","slide-1-title":"","slide-1-text-below":"","slide-1-url":"\/collections\/switches-sockets\/abb?page=3","show-slide-2":true,"slide-2-content-alignment":"center","slide-2-text-shadow":false,"slide-2-text-color":"#000000","slide-2-text-above":"","slide-2-title":"","slide-2-text-below":"","slide-2-url":"\/collections\/switches-sockets\/abb?page=3","show-slide-3":true,"slide-3-content-alignment":"center","slide-3-text-shadow":false,"slide-3-text-color":"#000000","slide-3-text-above":"","slide-3-title":"","slide-3-text-below":"","slide-3-url":"\/collections\/electrical-testing\/","show-slide-4":true,"slide-4-content-alignment":"center","slide-4-text-shadow":false,"slide-4-text-color":"#000000","slide-4-text-above":"","slide-4-title":"","slide-4-text-below":"","slide-4-url":"\/collections\/sprinklers\/","show-slide-5":true,"slide-5-content-alignment":"center","slide-5-text-shadow":false,"slide-5-text-color":"#000000","slide-5-text-above":"","slide-5-title":"","slide-5-text-below":"","slide-5-url":"\/collections\/cartridges\/","home-video-embed":"","home-video-width":"full-width","home-video-text-color":"light","home-video-title":"","home-video-cta":"","home-video-url":"","home-feature-row-1-title":"New Products","home-feature-row-1-text-shadow":false,"home-feature-1":false,"home-feature-1-text-above":"","home-feature-1-title":"New added","home-feature-1-text-below":"","home-feature-1-url":"https:\/\/bestomart.myshopify.com\/admin\/collections\/130106307","home-feature-1-text-color":"dark","home-feature-1-text-position":"center","home-feature-2":false,"home-feature-2-text-above":"","home-feature-2-title":"","home-feature-2-text-below":"","home-feature-2-url":"","home-feature-2-text-color":"light","home-feature-2-text-position":"left","home-feature-3":false,"home-feature-3-text-above":"","home-feature-3-title":"","home-feature-3-text-below":"","home-feature-3-url":"","home-feature-3-text-color":"light","home-feature-3-text-position":"left","home-feature-row-2-title":"","home-feature-row-2-text-shadow":false,"home-feature-4":false,"home-feature-4-text-above":"","home-feature-4-title":"","home-feature-4-text-below":"","home-feature-4-url":"","home-feature-4-text-color":"light","home-feature-4-text-position":"left","home-feature-5":false,"home-feature-5-text-above":"","home-feature-5-title":"","home-feature-5-text-below":"","home-feature-5-url":"","home-feature-5-text-color":"light","home-feature-5-text-position":"left","home-feature-6":false,"home-feature-6-text-above":"","home-feature-6-title":"","home-feature-6-text-below":"","home-feature-6-url":"","home-feature-6-text-color":"light","home-feature-6-text-position":"left","home-feature-row-3-title":"","home-feature-row-3-text-shadow":false,"home-feature-7":false,"home-feature-7-text-above":"","home-feature-7-title":"","home-feature-7-text-below":"","home-feature-7-url":"","home-feature-7-text-color":"light","home-feature-7-text-position":"left","home-feature-8":false,"home-feature-8-text-above":"","home-feature-8-title":"","home-feature-8-text-below":"","home-feature-8-url":"","home-feature-8-text-color":"light","home-feature-8-text-position":"left","home-feature-9":false,"home-feature-9-text-above":"","home-feature-9-title":"","home-feature-9-text-below":"","home-feature-9-url":"","home-feature-9-text-color":"light","home-feature-9-text-position":"left","home-featured-collections-title":"Collections","home-featured-collection-1":"","home-featured-collection-1-text-shadow":false,"home-featured-collection-1-text-color":"dark","home-featured-collection-2":"packaging-shipping","home-featured-collection-2-text-shadow":false,"home-featured-collection-2-text-color":"dark","home-featured-collection-3":"","home-featured-collection-3-text-shadow":false,"home-featured-collection-3-text-color":"dark","home-featured-collection-4":"","home-featured-collection-4-text-shadow":false,"home-featured-collection-4-text-color":"dark","home-featured-products-title":"Top Selling Products","home-featured-products-max":"8","home-featured-products-per-row":"4","home-featured-products":"topselling-at-start","home-featured-products2-title":"New Products","home-featured-products2-max":"8","home-featured-products2-per-row":"4","home-featured-products2":"newly-added","home-imported-content-title":"","home-imported-content-page":"","home-embedded-content-alignment":"right","home-embedded-content-html":"","home-embedded-content-image":false,"home-blog-posts-title":"News","home-blog-posts-number":"3","home-blog-posts-blog":"news","collections-link-list":"","collections-title-override":"","collections-text-style":"under","collections-show-descriptions":true,"collections-per-page":"12","collections-per-row":"4","collection-description":true,"collection-featured-image":true,"collection-sorting":true,"collection-layout-style":"uniform","collection-product-text-style":"under","collection-products-per-row":"4","collection-products-per-page":"12","collection-filtering":true,"collection-filter-link-list-1":"","collection-filter-link-list-2":"","collection-filter-link-list-3":"","collection-stock-level-overlay":true,"collection-stock-level-overlay-threshold":"0","collection-stock-level-overlay-text":"Only {NUM} Left!","product-enable-zoom":true,"product-enable-flip":true,"enable-related-products":false,"enable-product-quantity":true,"product-modules-order":"A-B-D-C","product-column-layout":"three-column","articles-per-page":"3","blog-show-rss-icon":true,"blog-show-tags":true,"blog-show-author":false,"blog-show-comment-count":true,"blog-show-share-buttons":true,"cart-special-instructions":false,"cart-shipping-calculator":false,"shipping-calculator-default-country":"India","foot-promo":true,"foot-promo-text":"\u003cmarquee width=\"100%\" direction=\"left\" behavior=\"scroll\" scrollamount=\"5\" height=\"80\"\u003e\u003cimg src=\"https:\/\/cdn.shopify.com\/s\/files\/1\/0912\/2482\/files\/brand7.png?17348832925857325657\" alt=\"Brand\"\u003e\u003cimg src=\"https:\/\/cdn.shopify.com\/s\/files\/1\/0912\/2482\/files\/brand7.png?17348832925857325657\" alt=\"Brand\"\u003e\u003cimg src=\"https:\/\/cdn.shopify.com\/s\/files\/1\/0912\/2482\/files\/brand7.png?17348832925857325657\" alt=\"Brand\"\u003e\u003c\/marquee\u003e","footer-promo-1":false,"footer-promo-1-url":"","footer-promo-2":false,"footer-promo-2-url":"","footer-promo-3":false,"footer-promo-3-url":"","footer-modules-order":"A-E-B","footer-titles":true,"footer-link-list-1":"footer","footer-link-list-2":"","footer-text-box-title":"Contact Address","footer-text-box":"Bestomart Internet Private Limited","footer-twitter-id":"","footer-twitter-retweets":false,"footer-instagram-access-token":"","footer-instagram-count":"3","footer-instagram-use-tag":false,"footer-instagram-tag":"","footer-show-payment-options":true,"newsletter-platform":"mailchimp","newsletter-action-url":"","campaign-monitor-name":"","social-facebook-url":"https:\/\/www.facebook.com\/Bestomart-195166444148440\/","social-twitter-url":"https:\/\/twitter.com\/bestomart","social-google-url":"https:\/\/plus.google.com\/104100808841511231559\/posts\/","social-pinterest-url":"https:\/\/www.pinterest.com\/bestomart\/","social-instagram-url":"https:\/\/instagram.com\/bestomart.info\/","social-kickstarter-url":"","social-vimeo-url":"","social-youtube-url":"","social-email-address":"","social-rss-url":"","share-widget-facebook":true,"share-widget-twitter":true,"share-widget-pinterest":true,"share-widget-fancy":true,"share-widget-google-plus":true,"share-widget-email":true,"twitter-handle":"","disable-ajax":false,"custom-css":"","checkout_header_image":null,"checkout_use_storefront_logo":false,"checkout_logo_image":null,"checkout_logo_position":"left","checkout_logo_size":"small","checkout_body_background_image":null,"checkout_body_background_color":"#fff","checkout_input_background_color_mode":"white","checkout_sidebar_background_image":null,"checkout_sidebar_background_color":"#fafafa","checkout_heading_font":"Helvetica Neue","checkout_body_font":"Helvetica Neue","checkout_accent_color":"#1990c6","checkout_button_color":"#009933","checkout_error_color":"#ff6d6d","mega-nav-item-text11":"Electrical \u0026 Electronics","mega-nav-111":true,"mega-nav-111-list":"electronics-electricals","mega-nav-111-use-image":true,"mega-nav-111-url":"\/collections\/electronics-electricals","mega-nav-112":true,"mega-nav-112-list":"","mega-nav-112-use-image":false,"mega-nav-112-url":"","mega-nav-113":false,"mega-nav-113-list":"","mega-nav-113-use-image":false,"mega-nav-113-url":"","mega-nav-114":false,"mega-nav-114-list":"","mega-nav-114-use-image":false,"mega-nav-114-url":"","mega-nav-121":true,"mega-nav-121-list":"soldering-welding","mega-nav-121-use-image":true,"mega-nav-121-url":"\/collections\/soldering-welding","mega-nav-122":true,"mega-nav-122-list":"","mega-nav-122-use-image":false,"mega-nav-122-url":"","mega-nav-123":false,"mega-nav-123-list":"","mega-nav-123-use-image":false,"mega-nav-123-url":"","mega-nav-124":false,"mega-nav-124-list":"","mega-nav-124-use-image":false,"mega-nav-124-url":"","mega-nav-131":true,"mega-nav-131-list":"security-safety","mega-nav-131-use-image":true,"mega-nav-131-url":"\/collections\/security-safety","mega-nav-132":true,"mega-nav-132-list":"","mega-nav-132-use-image":false,"mega-nav-132-url":"","mega-nav-133":false,"mega-nav-133-list":"","mega-nav-133-use-image":false,"mega-nav-133-url":"","mega-nav-134":false,"mega-nav-134-list":"","mega-nav-134-use-image":false,"mega-nav-134-url":"","mega-nav-item-text14":"Tools \u0026 Hardwares","mega-nav-141":true,"mega-nav-141-list":"hardwares-tools","mega-nav-141-use-image":true,"mega-nav-141-url":"\/collections\/hardwares-tools","mega-nav-142":true,"mega-nav-142-list":"","mega-nav-142-use-image":false,"mega-nav-142-url":"","mega-nav-143":false,"mega-nav-143-list":"","mega-nav-143-use-image":false,"mega-nav-143-url":"","mega-nav-144":false,"mega-nav-144-list":"","mega-nav-144-use-image":false,"mega-nav-144-url":"","mega-nav-item-text151":"Offers","mega-nav-151":true,"mega-nav-151-list":"offers","mega-nav-151-use-image":false,"mega-nav-151-url":"\/collections\/offers","mega-nav-item-text444":"Office  Supplies \u0026 IT","mega-nav-161":true,"mega-nav-161-list":"office-supplies-it","mega-nav-161-use-image":true,"mega-nav-161-url":"\/collections\/office-supplies-it","mega-nav-item-text445":"Test \u0026 Measure","mega-nav-171":true,"mega-nav-171-list":"test-measure","mega-nav-171-use-image":true,"mega-nav-171-url":"\/collections\/test-measure","mega-nav-item-text13":"Safety \u0026 Security","mega-nav-444-list":"office-supplies","mega-nav-444-use-image":false,"checkout_use_header_image":false,"checkout_logo":"checkout_logo.png","checkout_use_body_background_image":false,"checkout_use_sidebar_background_image":false,"mega-nav-item-text1":"All Categories","mega-nav-11":true,"mega-nav-11-list":"main-menu1","mega-nav-11-use-image":false,"mega-nav-11-url":"","mega-nav-12":false,"mega-nav-12-list":"footer","mega-nav-12-use-image":false,"mega-nav-12-url":"","mega-nav-13":false,"mega-nav-13-list":"","mega-nav-13-use-image":false,"mega-nav-13-url":"","mega-nav-14":false,"mega-nav-14-list":"tools","mega-nav-14-use-image":false,"mega-nav-14-url":"","currency-switcher-default":"CAD","collection-products-per-row-mobile":"1","customer_layout":"customer_area"}; 
          }; 

          ThemeView.prototype.render = function() { 
            var i, len, ref, rte; 
            new HeaderView({ 
              el: $(".main-header") 
            }); 
            new NavigationView({ 
              el: $(".navigation") 
            }); 
            new FooterView({ 
              el: $("footer") 
            }); 
            ref = $(".rte"); 
            for (i = 0, len = ref.length; i < len; i++) { 
              rte = ref[i]; 
              new RTEView({ 
                el: rte 
              }); 
            } 
            if (Pacific.settings["enable-currency-switcher"]) { 
              new CurrencyView({ 
                el: this.$(".currency-switcher") 
              }); 
            } 
            if (Pacific.settings["enable-sidebar"]) { 
              new SidebarView({ 
                el: this.$(".sidebar") 
              }); 
            } 
            if (this.isHome) { 
              new HomeView({ 
                el: this.$el 
              }); 
            } 
            if (this.isCollection) { 
              new CollectionView({ 
                el: this.$el 
              }); 
            } 
            if (this.isListCollections) { 
              new ListCollectionsView({ 
                el: $(".collections-list") 
              }); 
            } 
            if (this.isProduct) { 
              new ProductView({ 
                el: this.$el 
              }); 
            } 
            if (this.isCart) { 
              new CartView({ 
                el: this.$el 
              }); 
            } 
            if (this.isAccount) { 
              new AccountView({ 
                el: this.$el 
              }); 
            } 
            if ($("html").hasClass("lt-ie10")) { 
              return this.inputPlaceholderFix(); 
            } 
          }; 

          ThemeView.prototype.inputPlaceholderFix = function() { 
            var i, input, len, placeholders, text; 
            placeholders = $("[placeholder]"); 
            for (i = 0, len = placeholders.length; i < len; i++) { 
              input = placeholders[i]; 
              input = $(input); 
              if (!(input.val().length > 0)) { 
                text = input.attr("placeholder"); 
                input.attr("value", text); 
                input.data("original-text", text); 
              } 
            } 
            placeholders.focus(function() { 
              input = $(this); 
              if (input.val() === input.data("original-text")) { 
                return input.val(""); 
              } 
            }); 
            return placeholders.blur(function() { 
              input = $(this); 
              if (input.val().length === 0) { 
                return input.val(input.data("original-text")); 
              } 
            }); 
          }; 

          return ThemeView; 

        })(Backbone.View); 

        $(function() { 
          window.theme = new ThemeView(); 
          return theme.render(); 
        }); 

      }).call(this); 
